import { generateUniqueId, validateSchema, UnisphereLoggerFactory, getOrCreateGlobalUnisphere, isUnisphereEnvManifestJsonV2 } from '@unisphere/core';
import { isRuntimeOverrides } from '@unisphere/runtime';

class UnisphereElementFactory {}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$t = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$s = fails$t;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$s(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$r = fails$t;

var functionBindNative = !fails$r(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$q = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var functionCall = NATIVE_BIND$3 ? call$q.bind(call$q) : function () {
  return call$q.apply(call$q, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$4 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$4 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$4(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$8 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$p = FunctionPrototype$2.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$p, call$p);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$p.apply(fn, arguments);
  };
};

var uncurryThis$u = functionUncurryThis;

var toString$f = uncurryThis$u({}.toString);
var stringSlice$8 = uncurryThis$u(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$8(toString$f(it), 8, -1);
};

var uncurryThis$t = functionUncurryThis;
var fails$q = fails$t;
var classof$9 = classofRaw$2;

var $Object$4 = Object;
var split$3 = uncurryThis$t(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$q(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$9(it) === 'String' ? split$3(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$6 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$5 = isNullOrUndefined$6;

var $TypeError$j = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$9 = function (it) {
  if (isNullOrUndefined$5(it)) throw new $TypeError$j("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$8 = requireObjectCoercible$9;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$8(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$p = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$o = isCallable$p;

var isObject$e = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$o(it);
};

var globalThis$t = globalThis_1;
var isCallable$n = isCallable$p;

var aFunction = function (argument) {
  return isCallable$n(argument) ? argument : undefined;
};

var getBuiltIn$d = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis$t[namespace]) : globalThis$t[namespace] && globalThis$t[namespace][method];
};

var uncurryThis$s = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$s({}.isPrototypeOf);

var globalThis$s = globalThis_1;

var navigator = globalThis$s.navigator;
var userAgent$5 = navigator && navigator.userAgent;

var environmentUserAgent = userAgent$5 ? String(userAgent$5) : '';

var globalThis$r = globalThis_1;
var userAgent$4 = environmentUserAgent;

var process$3 = globalThis$r.process;
var Deno$1 = globalThis$r.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$4) {
  match = userAgent$4.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$4.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = environmentV8Version;
var fails$p = fails$t;
var globalThis$q = globalThis_1;

var $String$5 = globalThis$q.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$p(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1 &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

var getBuiltIn$c = getBuiltIn$d;
var isCallable$m = isCallable$p;
var isPrototypeOf$4 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$c('Symbol');
  return isCallable$m($Symbol) && isPrototypeOf$4($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$4 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$l = isCallable$p;
var tryToString$3 = tryToString$4;

var $TypeError$i = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$e = function (argument) {
  if (isCallable$l(argument)) return argument;
  throw new $TypeError$i(tryToString$3(argument) + ' is not a function');
};

var aCallable$d = aCallable$e;
var isNullOrUndefined$4 = isNullOrUndefined$6;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$6 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$4(func) ? undefined : aCallable$d(func);
};

var call$o = functionCall;
var isCallable$k = isCallable$p;
var isObject$d = isObject$e;

var $TypeError$h = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$k(fn = input.toString) && !isObject$d(val = call$o(fn, input))) return val;
  if (isCallable$k(fn = input.valueOf) && !isObject$d(val = call$o(fn, input))) return val;
  if (pref !== 'string' && isCallable$k(fn = input.toString) && !isObject$d(val = call$o(fn, input))) return val;
  throw new $TypeError$h("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var isPure = false;

var globalThis$p = globalThis_1;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$9 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$9(globalThis$p, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis$p[key] = value;
  } return value;
};

var globalThis$o = globalThis_1;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$o[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.41.0',
  mode: 'global',
  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.41.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var sharedStoreExports = sharedStore.exports;

var store$2 = sharedStoreExports;

var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$7 = requireObjectCoercible$9;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$7 = function (argument) {
  return $Object$2(requireObjectCoercible$7(argument));
};

var uncurryThis$r = functionUncurryThis;
var toObject$6 = toObject$7;

var hasOwnProperty = uncurryThis$r({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$6(it), key);
};

var uncurryThis$q = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$e = uncurryThis$q(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$e(++id + postfix, 36);
};

var globalThis$n = globalThis_1;
var shared$3 = shared$4;
var hasOwn$g = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$1 = globalThis$n.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$m = function (name) {
  if (!hasOwn$g(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$g(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$n = functionCall;
var isObject$c = isObject$e;
var isSymbol$1 = isSymbol$2;
var getMethod$5 = getMethod$6;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$l = wellKnownSymbol$m;

var $TypeError$g = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$l('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$c(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$5(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$n(exoticToPrim, input, pref);
    if (!isObject$c(result) || isSymbol$1(result)) return result;
    throw new $TypeError$g("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var globalThis$m = globalThis_1;
var isObject$b = isObject$e;

var document$3 = globalThis$m.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$b(document$3) && isObject$b(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$m = descriptors;
var fails$o = fails$t;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$m && !fails$o(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$l = descriptors;
var call$m = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$7 = createPropertyDescriptor$8;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$f = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$l ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$f(O, P)) return createPropertyDescriptor$7(!call$m(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$k = descriptors;
var fails$n = fails$t;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$k && fails$n(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$a = isObject$e;

var $String$3 = String;
var $TypeError$f = TypeError;

// `Assert: Type(argument) is Object`
var anObject$p = function (argument) {
  if (isObject$a(argument)) return argument;
  throw new $TypeError$f($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$j = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$o = anObject$p;
var toPropertyKey = toPropertyKey$2;

var $TypeError$e = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$j ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$o(O);
  P = toPropertyKey(P);
  anObject$o(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$o(O);
  P = toPropertyKey(P);
  anObject$o(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$e('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$i = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$6 = createPropertyDescriptor$8;

var createNonEnumerableProperty$9 = DESCRIPTORS$i ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$6(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$h = descriptors;
var hasOwn$e = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$h && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$e(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$h || (DESCRIPTORS$h && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$p = functionUncurryThis;
var isCallable$j = isCallable$p;
var store$1 = sharedStoreExports;

var functionToString = uncurryThis$p(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$j(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var globalThis$l = globalThis_1;
var isCallable$i = isCallable$p;

var WeakMap$2 = globalThis$l.WeakMap;

var weakMapBasicDetection = isCallable$i(WeakMap$2) && /native code/.test(String(WeakMap$2));

var shared$2 = shared$4;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var globalThis$k = globalThis_1;
var isObject$9 = isObject$e;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$9;
var hasOwn$d = hasOwnProperty_1;
var shared$1 = sharedStoreExports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$4 = globalThis$k.TypeError;
var WeakMap$1 = globalThis$k.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor$1 = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$9(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$4('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw new TypeError$4(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$d(it, STATE)) throw new TypeError$4(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$8(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$d(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$d(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor$1
};

var uncurryThis$o = functionUncurryThis;
var fails$m = fails$t;
var isCallable$h = isCallable$p;
var hasOwn$c = hasOwnProperty_1;
var DESCRIPTORS$g = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$7 = internalState;

var enforceInternalState = InternalStateModule$7.enforce;
var getInternalState$4 = InternalStateModule$7.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$8 = Object.defineProperty;
var stringSlice$7 = uncurryThis$o(''.slice);
var replace$8 = uncurryThis$o(''.replace);
var join$4 = uncurryThis$o([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$g && !fails$m(function () {
  return defineProperty$8(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$7($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$8($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$c(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$g) defineProperty$8(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$c(options, 'arity') && value.length !== options.arity) {
    defineProperty$8(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$c(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$g) defineProperty$8(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$c(state, 'source')) {
    state.source = join$4(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$h(this) && getInternalState$4(this).source || inspectSource$2(this);
}, 'toString');

var makeBuiltInExports = makeBuiltIn$3.exports;

var isCallable$g = isCallable$p;
var definePropertyModule$3 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltInExports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$d = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$g(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$3.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$4 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$4 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$4 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;

var max$1 = Math.max;
var min$3 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$2 = function (index, length) {
  var integer = toIntegerOrInfinity$3(index);
  return integer < 0 ? max$1(integer + length, 0) : min$3(integer, length);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  var len = toIntegerOrInfinity$2(argument);
  return len > 0 ? min$2(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$2 = toLength$3;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$5 = function (obj) {
  return toLength$2(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex$1 = toAbsoluteIndex$2;
var lengthOfArrayLike$4 = lengthOfArrayLike$5;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$4(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var uncurryThis$n = functionUncurryThis;
var hasOwn$b = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$5 = uncurryThis$n([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$b(hiddenKeys$2, key) && hasOwn$b(O, key) && push$5(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$b(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$5(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$b = getBuiltIn$d;
var uncurryThis$m = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$n = anObject$p;

var concat$2 = uncurryThis$m([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$b('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$n(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$a = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$a(target, key) && !(exceptions && hasOwn$a(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$l = fails$t;
var isCallable$f = isCallable$p;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$f(detection) ? fails$l(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var globalThis$j = globalThis_1;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$9;
var defineBuiltIn$c = defineBuiltIn$d;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis$j;
  } else if (STATIC) {
    target = globalThis$j[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis$j[TARGET] && globalThis$j[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$3(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$7(sourceProperty, 'sham', true);
    }
    defineBuiltIn$c(target, key, sourceProperty, options);
  }
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$3 = FunctionPrototype.apply;
var call$l = FunctionPrototype.call;

// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$l.bind(apply$3) : function () {
  return call$l.apply(apply$3, arguments);
});

var uncurryThis$l = functionUncurryThis;
var aCallable$c = aCallable$e;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$l(aCallable$c(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$8 = isObject$e;

var isPossiblePrototype$1 = function (argument) {
  return isObject$8(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$1 = String;
var $TypeError$d = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$d("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject$7 = isObject$e;
var requireObjectCoercible$6 = requireObjectCoercible$9;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$6(O);
    aPossiblePrototype(proto);
    if (!isObject$7(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$7 = objectDefineProperty.f;

var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty$7(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var isCallable$e = isCallable$p;
var isObject$6 = isObject$e;
var setPrototypeOf$3 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$2 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$3 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$e(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$6(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$3($this, NewTargetPrototype);
  return $this;
};

var wellKnownSymbol$k = wellKnownSymbol$m;

var TO_STRING_TAG$4 = wellKnownSymbol$k('toStringTag');
var test = {};

test[TO_STRING_TAG$4] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$d = isCallable$p;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$j = wellKnownSymbol$m;

var TO_STRING_TAG$3 = wellKnownSymbol$j('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$8 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$3)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$d(O.callee) ? 'Arguments' : result;
};

var classof$7 = classof$8;

var $String = String;

var toString$d = function (argument) {
  if (classof$7(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var toString$c = toString$d;

var normalizeStringArgument$4 = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$c(argument);
};

var isObject$5 = isObject$e;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$9;

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause$1 = function (O, options) {
  if (isObject$5(options) && 'cause' in options) {
    createNonEnumerableProperty$6(O, 'cause', options.cause);
  }
};

var uncurryThis$k = functionUncurryThis;

var $Error = Error;
var replace$7 = uncurryThis$k(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

var errorStackClear = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace$7(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};

var fails$k = fails$t;
var createPropertyDescriptor$5 = createPropertyDescriptor$8;

var errorStackInstallable = !fails$k(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor$5(1, 7));
  return error.stack !== 7;
});

var createNonEnumerableProperty$5 = createNonEnumerableProperty$9;
var clearErrorStack$2 = errorStackClear;
var ERROR_STACK_INSTALLABLE = errorStackInstallable;

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

var errorStackInstall = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty$5(error, 'stack', clearErrorStack$2(stack, dropEntries));
  }
};

var getBuiltIn$a = getBuiltIn$d;
var hasOwn$9 = hasOwnProperty_1;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$9;
var isPrototypeOf$3 = objectIsPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var copyConstructorProperties = copyConstructorProperties$2;
var proxyAccessor = proxyAccessor$1;
var inheritIfRequired$1 = inheritIfRequired$2;
var normalizeStringArgument$3 = normalizeStringArgument$4;
var installErrorCause = installErrorCause$1;
var installErrorStack = errorStackInstall;
var DESCRIPTORS$f = descriptors;

var wrapErrorConstructorWithCause$1 = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn$a.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (hasOwn$9(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn$a('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument$3(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty$4(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf$3(OriginalErrorPrototype, this)) inheritIfRequired$1(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf$2) setPrototypeOf$2(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS$f && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty$4(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $$t = _export;
var globalThis$i = globalThis_1;
var apply$2 = functionApply;
var wrapErrorConstructorWithCause = wrapErrorConstructorWithCause$1;

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = globalThis$i[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED$4 = new Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED$4);
  $$t({ global: true, constructor: true, arity: 1, forced: FORCED$4 }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED$4);
    $$t({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED$4 }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply$2(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply$2(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply$2(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply$2(init, this, arguments); };
});

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$e = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$1 = objectDefineProperty;
var anObject$m = anObject$p;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$e && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$m(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$9 = getBuiltIn$d;

var html$2 = getBuiltIn$9('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$l = anObject$p;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$l(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$i = wellKnownSymbol$m;
var create$5 = objectCreate;
var defineProperty$6 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$i('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$6(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$5(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$j = fails$t;

var correctPrototypeGetter = !fails$j(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$8 = hasOwnProperty_1;
var isCallable$c = isCallable$p;
var toObject$5 = toObject$7;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$5(O);
  if (hasOwn$8(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$c(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails$i = fails$t;
var isCallable$b = isCallable$p;
var isObject$4 = isObject$e;
var getPrototypeOf$2 = objectGetPrototypeOf;
var defineBuiltIn$b = defineBuiltIn$d;
var wellKnownSymbol$h = wellKnownSymbol$m;

var ITERATOR$8 = wellKnownSymbol$h('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$4, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$2(getPrototypeOf$2(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$4 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$4(IteratorPrototype$4) || fails$i(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$4[ITERATOR$8].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$4 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$b(IteratorPrototype$4[ITERATOR$8])) {
  defineBuiltIn$b(IteratorPrototype$4, ITERATOR$8, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$4,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$5 = objectDefineProperty.f;
var hasOwn$7 = hasOwnProperty_1;
var wellKnownSymbol$g = wellKnownSymbol$m;

var TO_STRING_TAG$2 = wellKnownSymbol$g('toStringTag');

var setToStringTag$7 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$7(target, TO_STRING_TAG$2)) {
    defineProperty$5(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$3 = iteratorsCore.IteratorPrototype;
var create$4 = objectCreate;
var createPropertyDescriptor$4 = createPropertyDescriptor$8;
var setToStringTag$6 = setToStringTag$7;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$4(IteratorPrototype$3, { next: createPropertyDescriptor$4(+!ENUMERABLE_NEXT, next) });
  setToStringTag$6(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$s = _export;
var call$k = functionCall;
var FunctionName = functionName;
var isCallable$a = isCallable$p;
var createIteratorConstructor$1 = iteratorCreateConstructor;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$5 = setToStringTag$7;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$9;
var defineBuiltIn$a = defineBuiltIn$d;
var wellKnownSymbol$f = wellKnownSymbol$m;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype$2 = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$7 = wellKnownSymbol$f('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$7]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$1(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable$a(CurrentIteratorPrototype[ITERATOR$7])) {
          defineBuiltIn$a(CurrentIteratorPrototype, ITERATOR$7, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$5(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$2 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$3(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$k(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$a(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$s({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$7] !== defaultIterator) {
    defineBuiltIn$a(IterablePrototype, ITERATOR$7, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$4 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators$2 = iterators;
var InternalStateModule$6 = internalState;
var defineProperty$4 = objectDefineProperty.f;
var defineIterator$1 = iteratorDefine;
var createIterResultObject$3 = createIterResultObject$4;
var DESCRIPTORS$d = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$6 = InternalStateModule$6.set;
var getInternalState$3 = InternalStateModule$6.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator$1(Array, 'Array', function (iterated, kind) {
  setInternalState$6(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$3(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject$3(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$3(index, false);
    case 'values': return createIterResultObject$3(target[index], false);
  } return createIterResultObject$3([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$d && values.name !== 'values') try {
  defineProperty$4(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var classof$6 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
  return classof$6(argument) === 'Array';
};

var DESCRIPTORS$c = descriptors;
var isArray = isArray$1;

var $TypeError$c = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS$c && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor$2(O, 'length').writable) {
    throw new $TypeError$c('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError$b = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$b('Maximum allowed index exceeded');
  return it;
};

var $$r = _export;
var toObject$4 = toObject$7;
var lengthOfArrayLike$3 = lengthOfArrayLike$5;
var setArrayLength = arraySetLength;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$1;
var fails$h = fails$t;

var INCORRECT_TO_LENGTH = fails$h(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED$3 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$$r({ target: 'Array', proto: true, arity: 1, forced: FORCED$3 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject$4(this);
    var len = lengthOfArrayLike$3(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});

var isPrototypeOf$2 = objectIsPrototypeOf;

var $TypeError$a = TypeError;

var anInstance$6 = function (it, Prototype) {
  if (isPrototypeOf$2(Prototype, it)) return it;
  throw new $TypeError$a('Incorrect invocation');
};

var makeBuiltIn = makeBuiltInExports;
var defineProperty$3 = objectDefineProperty;

var defineBuiltInAccessor$6 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$3.f(target, name, descriptor);
};

var DESCRIPTORS$b = descriptors;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$8;

var createProperty$2 = function (object, key, value) {
  if (DESCRIPTORS$b) definePropertyModule.f(object, key, createPropertyDescriptor$3(0, value));
  else object[key] = value;
};

var $$q = _export;
var globalThis$h = globalThis_1;
var anInstance$5 = anInstance$6;
var anObject$k = anObject$p;
var isCallable$9 = isCallable$p;
var getPrototypeOf = objectGetPrototypeOf;
var defineBuiltInAccessor$5 = defineBuiltInAccessor$6;
var createProperty$1 = createProperty$2;
var fails$g = fails$t;
var hasOwn$6 = hasOwnProperty_1;
var wellKnownSymbol$e = wellKnownSymbol$m;
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var DESCRIPTORS$a = descriptors;

var CONSTRUCTOR = 'constructor';
var ITERATOR$6 = 'Iterator';
var TO_STRING_TAG$1 = wellKnownSymbol$e('toStringTag');

var $TypeError$9 = TypeError;
var NativeIterator = globalThis$h[ITERATOR$6];

// FF56- have non-standard global helper `Iterator`
var FORCED$2 = !isCallable$9(NativeIterator)
  || NativeIterator.prototype !== IteratorPrototype$1
  // FF44- non-standard `Iterator` passes previous tests
  || !fails$g(function () { NativeIterator({}); });

var IteratorConstructor = function Iterator() {
  anInstance$5(this, IteratorPrototype$1);
  if (getPrototypeOf(this) === IteratorPrototype$1) throw new $TypeError$9('Abstract class Iterator not directly constructable');
};

var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS$a) {
    defineBuiltInAccessor$5(IteratorPrototype$1, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject$k(this);
        if (this === IteratorPrototype$1) throw new $TypeError$9("You can't redefine this property");
        if (hasOwn$6(this, key)) this[key] = replacement;
        else createProperty$1(this, key, replacement);
      }
    });
  } else IteratorPrototype$1[key] = value;
};

if (!hasOwn$6(IteratorPrototype$1, TO_STRING_TAG$1)) defineIteratorPrototypeAccessor(TO_STRING_TAG$1, ITERATOR$6);

if (FORCED$2 || !hasOwn$6(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype$1;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$$q({ global: true, constructor: true, forced: FORCED$2 }, {
  Iterator: IteratorConstructor
});

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
var getIteratorDirect$5 = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};

var defineBuiltIn$9 = defineBuiltIn$d;

var defineBuiltIns$2 = function (target, src, options) {
  for (var key in src) defineBuiltIn$9(target, key, src[key], options);
  return target;
};

var call$j = functionCall;
var anObject$j = anObject$p;
var getMethod$4 = getMethod$6;

var iteratorClose$3 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$j(iterator);
  try {
    innerResult = getMethod$4(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$j(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$j(innerResult);
  return value;
};

var call$i = functionCall;
var create$3 = objectCreate;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$9;
var defineBuiltIns$1 = defineBuiltIns$2;
var wellKnownSymbol$d = wellKnownSymbol$m;
var InternalStateModule$5 = internalState;
var getMethod$3 = getMethod$6;
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var createIterResultObject$2 = createIterResultObject$4;
var iteratorClose$2 = iteratorClose$3;

var TO_STRING_TAG = wellKnownSymbol$d('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var setInternalState$5 = InternalStateModule$5.set;

var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule$5.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);

  return defineBuiltIns$1(create$3(IteratorPrototype), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      if (state.done) return createIterResultObject$2(undefined, true);
      try {
        var result = state.nextHandler();
        return state.returnHandlerResult ? result : createIterResultObject$2(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod$3(iterator, 'return');
        return returnMethod ? call$i(returnMethod, iterator) : createIterResultObject$2(undefined, true);
      }
      if (state.inner) try {
        iteratorClose$2(state.inner.iterator, 'normal');
      } catch (error) {
        return iteratorClose$2(iterator, 'throw', error);
      }
      if (iterator) iteratorClose$2(iterator, 'normal');
      return createIterResultObject$2(undefined, true);
    }
  });
};

var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);

createNonEnumerableProperty$2(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');

var iteratorCreateProxy = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState$5(this, state);
  };

  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;

  return IteratorProxy;
};

var anObject$i = anObject$p;
var iteratorClose$1 = iteratorClose$3;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$2 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$i(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$1(iterator, 'throw', error);
  }
};

var $$p = _export;
var call$h = functionCall;
var aCallable$b = aCallable$e;
var anObject$h = anObject$p;
var getIteratorDirect$4 = getIteratorDirect$5;
var createIteratorProxy = iteratorCreateProxy;
var callWithSafeIterationClosing$1 = callWithSafeIterationClosing$2;
var IS_PURE$1 = isPure;

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject$h(call$h(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing$1(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://tc39.es/ecma262/#sec-iterator.prototype.filter
$$p({ target: 'Iterator', proto: true, real: true, forced: IS_PURE$1 }, {
  filter: function filter(predicate) {
    anObject$h(this);
    aCallable$b(predicate);
    return new IteratorProxy(getIteratorDirect$4(this), {
      predicate: predicate
    });
  }
});

var classofRaw = classofRaw$2;
var uncurryThis$j = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$j(fn);
};

var uncurryThis$i = functionUncurryThisClause;
var aCallable$a = aCallable$e;
var NATIVE_BIND = functionBindNative;

var bind$7 = uncurryThis$i(uncurryThis$i.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$a(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$7(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var wellKnownSymbol$c = wellKnownSymbol$m;
var Iterators$1 = iterators;

var ITERATOR$5 = wellKnownSymbol$c('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$2 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$5] === it);
};

var classof$5 = classof$8;
var getMethod$2 = getMethod$6;
var isNullOrUndefined$3 = isNullOrUndefined$6;
var Iterators = iterators;
var wellKnownSymbol$b = wellKnownSymbol$m;

var ITERATOR$4 = wellKnownSymbol$b('iterator');

var getIteratorMethod$4 = function (it) {
  if (!isNullOrUndefined$3(it)) return getMethod$2(it, ITERATOR$4)
    || getMethod$2(it, '@@iterator')
    || Iterators[classof$5(it)];
};

var call$g = functionCall;
var aCallable$9 = aCallable$e;
var anObject$g = anObject$p;
var tryToString$2 = tryToString$4;
var getIteratorMethod$3 = getIteratorMethod$4;

var $TypeError$8 = TypeError;

var getIterator$3 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$3(argument) : usingIterator;
  if (aCallable$9(iteratorMethod)) return anObject$g(call$g(iteratorMethod, argument));
  throw new $TypeError$8(tryToString$2(argument) + ' is not iterable');
};

var bind$6 = functionBindContext;
var call$f = functionCall;
var anObject$f = anObject$p;
var tryToString$1 = tryToString$4;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$2;
var lengthOfArrayLike$2 = lengthOfArrayLike$5;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getIterator$2 = getIterator$3;
var getIteratorMethod$2 = getIteratorMethod$4;
var iteratorClose = iteratorClose$3;

var $TypeError$7 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$6 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$6(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$f(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$2(iterable);
    if (!iterFn) throw new $TypeError$7(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$2(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$1(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$2(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$f(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$1(ResultPrototype, result)) return result;
  } return new Result(false);
};

var $$o = _export;
var iterate$5 = iterate$6;
var aCallable$8 = aCallable$e;
var anObject$e = anObject$p;
var getIteratorDirect$3 = getIteratorDirect$5;

// `Iterator.prototype.find` method
// https://tc39.es/ecma262/#sec-iterator.prototype.find
$$o({ target: 'Iterator', proto: true, real: true }, {
  find: function find(predicate) {
    anObject$e(this);
    aCallable$8(predicate);
    var record = getIteratorDirect$3(this);
    var counter = 0;
    return iterate$5(record, function (value, stop) {
      if (predicate(value, counter++)) return stop(value);
    }, { IS_RECORD: true, INTERRUPTED: true }).result;
  }
});

var $$n = _export;
var iterate$4 = iterate$6;
var aCallable$7 = aCallable$e;
var anObject$d = anObject$p;
var getIteratorDirect$2 = getIteratorDirect$5;

// `Iterator.prototype.forEach` method
// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
$$n({ target: 'Iterator', proto: true, real: true }, {
  forEach: function forEach(fn) {
    anObject$d(this);
    aCallable$7(fn);
    var record = getIteratorDirect$2(this);
    var counter = 0;
    iterate$4(record, function (value) {
      fn(value, counter++);
    }, { IS_RECORD: true });
  }
});

var DESCRIPTORS$9 = descriptors;
var uncurryThis$h = functionUncurryThis;
var call$e = functionCall;
var fails$f = fails$t;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$3 = toObject$7;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$2 = Object.defineProperty;
var concat$1 = uncurryThis$h([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$f(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$9 && $assign({ b: 1 }, $assign(defineProperty$2({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$2(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$3(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$9 || call$e(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$m = _export;
var assign$1 = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$m({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign$1 }, {
  assign: assign$1
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var globalThis$g = globalThis_1;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$9;
var setToStringTag$4 = setToStringTag$7;
var wellKnownSymbol$a = wellKnownSymbol$m;

var ITERATOR$3 = wellKnownSymbol$a('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    setToStringTag$4(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis$g[COLLECTION_NAME] && globalThis$g[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const defaultAreaName = 'default';
// DEPRECATION NOTICE: https://kaltura.atlassian.net/browse/UNISPHERE-245
/*
@deprecated use UnisphereRuntimeBase
*/
class UnisphereElementBase {
  _onSettingsUpdated(settings) {
    // empty by design
  }
  kill() {
    this._killed = true;
    this._logger.log('Unisphere widget is killed, unassigning all visual');
    this._visuals.forEach(visual => {
      this._onVisualUnmount(Object.assign({}, visual));
    });
    this._onKilled();
  }
  _getVisuals() {
    return this._visuals;
  }
  constructor(options) {
    var _a;
    this._visuals = [];
    this._theme = null;
    this._language = 'en';
    this._killed = false;
    const maybeLogger = (_a = options.getService('unisphere.service.logger')) === null || _a === void 0 ? void 0 : _a.getOrCreateLogger('runtime', 'unisphere-runtime-base', {
      widgetName: options.widgetName,
      runtimeName: options.runtimeName
    });
    if (!maybeLogger) {
      throw new Error('missing logger service, cannot create element');
    }
    this._logger = maybeLogger;
    this._options = options;
    this._workspace = options.getWorkspace();
    this._runtimeSettings = options.settings;
    this._services = {
      utils: options.getService('unisphere.service.utils'),
      pubSub: options.getService('unisphere.service.pub-sub'),
      theme: options.getService('unisphere.service.theme'),
      storage: options.getService('unisphere.service.storage'),
      iframes: options.getService('unisphere.service.iframes'),
      userSettings: options.getService('unisphere.service.user-settings'),
      developer: options.getService('unisphere.service.developer') || null
    };
    this._workspaceName = options.getWorkspace().getWorkspaceName();
    this._services.theme.onThemeChanged(theme => {
      this._theme = theme;
      this._reMountAllVisuals();
    });
    this._services.userSettings.onLanguageChanged(language => {
      this._language = language;
      this._reMountAllVisuals();
    });
    if (options.settingsSchema && this._services.utils.validateSchema(options.settings, options.settingsSchema, 'element (legacy) settings', this._logger).length) {
      throw new Error(`Invalid settings provided for element (legacy), cannot create element (in the console log, look for warning starting with 'Validation errors for settings')`);
    }
  }
  updateSettings(settingsOrCreator) {
    this._logger.log(`Updating element settings`);
    const newSettings = typeof settingsOrCreator === 'object' ? settingsOrCreator : settingsOrCreator(this._options.settings);
    if (!newSettings || !this._options.settingsSchema || this._services.utils.validateSchema(newSettings, this._options.settingsSchema, 'element settings', this._logger).length) {
      this._logger.error(`Invalid new settings provided, cannot update element runtime with them.`);
      return;
    }
    this._logger.debug(`New settings`, {
      data: newSettings
    });
    this._options.settings = newSettings;
    this._onSettingsUpdated(newSettings);
    this._reMountAllVisuals();
  }
  _reMountAllVisuals() {
    this._visuals.forEach(visual => {
      try {
        if (!this._onVisualMount(Object.assign({}, visual))) {
          this._logger.warn(`failed to re-mount visual type: ${visual.type} as the inherited class failed to mount it, visual html element will remain empty`);
        }
      } catch (error) {
        this._logger.error(`Failed to re-mount visual with type '${visual.type}' due to an error, ${error === null || error === void 0 ? void 0 : error.message}`, {
          error
        });
      }
    });
  }
  _reMountVisualByType(type, id) {
    const visuals = this._visuals.filter(visual => visual.type === type && (!id || visual.id === id));
    if (!visuals.length) {
      return;
    }
    visuals.forEach(visual => {
      try {
        if (!this._onVisualMount(Object.assign({}, visual))) {
          this._logger.warn(`failed to mount visual type: ${visual.type} (remount visual by type) as the inherited class failed to mount it, visual html element will remain empty`);
        }
      } catch (error) {
        this._logger.error(`Failed to mount visual with type '${visual.type}' (remount visual by type) due to an error, ${error === null || error === void 0 ? void 0 : error.message}`, {
          error
        });
      }
    });
  }
  /*
  @deprecated removed from api
  */
  hasArea() {
    return this.hasAreaByName(defaultAreaName);
  }
  /*
  @deprecated removed from api
  */
  hasAreaByName(areaName) {
    const resolveTypeByName = this._resolveVisualTypeByLegacyAreaName(areaName || defaultAreaName);
    if (!resolveTypeByName) {
      return false;
    }
    return !!this._visuals.find(visual => visual.type === resolveTypeByName && visual.id === areaName);
  }
  /*
  @deprecated removed from api
  */
  getArea() {
    this._logger.warn('UnisphereElementBase.getArea() is deprecated, use visuals instead');
    return this.getAreaByName(defaultAreaName);
  }
  /*
  @deprecated use mountVisual instead
  */
  assignArea(area) {
    /*
    DEPRECATION NOTICE: https://kaltura.atlassian.net/browse/UNISPHERE-246
    you can move the content of this method directly to the unisphere workspace loadRuntimes until handling https://kaltura.atlassian.net/browse/UNISPHERE-247
    */
    this.assignAreaByName(defaultAreaName, area);
  }
  unassignArea() {
    /*
    DEPRECATION NOTICE: https://kaltura.atlassian.net/browse/UNISPHERE-246
    you can move the content of this method directly to the unisphere workspace loadRuntimes until handling https://kaltura.atlassian.net/browse/UNISPHERE-247
    */
    this.unassignAreaByName(defaultAreaName);
  }
  /*
  @deprecated removed from api
  */
  getAreaByName(areaName = '') {
    var _a;
    this._logger.warn('UnisphereElementBase.getAreaByName() is deprecated, use visuals instead');
    const resolvedAreaName = areaName || defaultAreaName;
    const resolveTypeByName = this._resolveVisualTypeByLegacyAreaName(resolvedAreaName);
    if (!resolveTypeByName) {
      return null;
    }
    return ((_a = this._visuals.find(element => element.type === resolveTypeByName && element.id === resolvedAreaName)) === null || _a === void 0 ? void 0 : _a.htmlContainer) || null;
  }
  _resolveVisualTypeByLegacyAreaName(areaName) {
    const resolveTypeByName = Object.entries(this._options.visualTypes).find(([, visualType]) => visualType.legacyAreaName === areaName);
    if (!resolveTypeByName) {
      this._logger.warn(`No visual type assigned for area '${areaName}'`);
      return;
    }
    return resolveTypeByName[0];
  }
  /*
  @deprecated use mountVisual instead
  */
  assignAreaByName(areaName, target) {
    /*
    DEPRECATION NOTICE: https://kaltura.atlassian.net/browse/UNISPHERE-246
    you can move the content of this method directly to the unisphere workspace loadRuntimes until handling https://kaltura.atlassian.net/browse/UNISPHERE-247
    */
    const resolveTypeByName = this._resolveVisualTypeByLegacyAreaName(areaName || defaultAreaName);
    if (!resolveTypeByName) {
      return;
    }
    this._mountVisual({
      type: resolveTypeByName,
      settings: this._options.settings,
      target
    }, {
      predefinedId: areaName,
      isLegacy: true
    });
  }
  /*
  @deprecated use unmountVisual instead
  */
  unassignAreaByName(areaName) {
    /*
    DEPRECATION NOTICE: https://kaltura.atlassian.net/browse/UNISPHERE-246
    you can move the content of this method directly to the unisphere workspace loadRuntimes until handling https://kaltura.atlassian.net/browse/UNISPHERE-247
    */
    const resolveTypeByName = this._resolveVisualTypeByLegacyAreaName(areaName || defaultAreaName);
    if (!resolveTypeByName) {
      return;
    }
    this.unmountVisual(areaName || defaultAreaName);
  }
  unmountVisual(id) {
    try {
      const visual = this._visuals.find(item => item.id === id);
      if (!visual) {
        this._logger.warn(`No visual assigned for '${id}', nothing to unmount`);
        return;
      }
      this._logger.log(`Unassigning visual for '${id}' of type ${visual.type}`);
      if (visual.htmlContainer) {
        this._onVisualUnmount(Object.assign({}, visual));
        if (visual.target && typeof visual.target !== 'string' && 'target' in visual.target && visual.target.target === 'body') {
          this._logger.log(`Removing visual element from body for '${id}'`);
          this._services.utils.removeVisualFromBody({
            widgetName: this.widgetName,
            runtimeName: this.runtimeName,
            visualId: id,
            logger: this._logger,
            workspaceName: this._workspaceName
          });
        }
        this._visuals = this._visuals.filter(element => !(element.id === id));
      } else {
        this._logger.log(`No visual assigned for '${id}', nothing to unassign`);
      }
    } catch (e) {
      this._logger.error(`Failed to unassign visual for '${id}'`, {
        error: e
      });
    }
  }
  mountVisual({
    type,
    target,
    settings
  }, options) {
    return this._mountVisual({
      type,
      target,
      settings
    }, options);
  }
  _preMountVisual(data, options) {
    return {
      target: data.target
    };
  }
  _mountVisual(data, options) {
    const {
      target: resolvedTarget
    } = this._preMountVisual(data, options);
    const {
      type,
      settings
    } = data;
    if (options === null || options === void 0 ? void 0 : options.isLegacy) {
      this._logger.warn(`Either the host of an other unisphere experience is loading this plugin using legacy areas API, migrate to visuals instead`);
    }
    try {
      if (this._killed) {
        this._logger.warn('Unisphere widget is killed, cannot assign area');
        return {
          id: '',
          unsubscribe: () => {}
        };
      }
      const resolvedId = (options === null || options === void 0 ? void 0 : options.predefinedId) || generateUniqueId();
      let existingVisualById = this._visuals.find(visual => {
        return visual.id === resolvedId;
      }) || null;
      let existingVisualByTarget = this._visuals.find(visual => {
        const compareToHtmlContainer = typeof resolvedTarget === 'string' ? document.getElementById(resolvedTarget) : resolvedTarget instanceof HTMLElement ? resolvedTarget : resolvedTarget.target === 'element' ? document.getElementById(resolvedTarget.elementId) : null;
        return compareToHtmlContainer && visual.htmlContainer === compareToHtmlContainer;
      }) || null;
      let visualToMountOrUpdate = existingVisualById || existingVisualByTarget;
      let forceUnmountExistingVisuals = false;
      if (existingVisualByTarget && existingVisualById && existingVisualById !== existingVisualByTarget) {
        forceUnmountExistingVisuals = true;
        this._logger.warn(`found two different visuals, one for id ${resolvedId} and another for requested target, unmounting both`);
      }
      if (existingVisualById && !existingVisualByTarget) {
        forceUnmountExistingVisuals = true;
        this._logger.warn(`Visual ${type} with id ${resolvedId} exists but with different target then requested, unmounting previous visual`);
      }
      if (forceUnmountExistingVisuals) {
        if (existingVisualById) {
          this.unmountVisual(existingVisualById.id);
        }
        if (existingVisualByTarget) {
          this.unmountVisual(existingVisualByTarget.id);
        }
        visualToMountOrUpdate = null;
      }
      const isUpdatingExistingVisual = !!visualToMountOrUpdate;
      this._logger.log(`${isUpdatingExistingVisual ? 'Updating' : 'Mounting'} visual ${type} with id ${resolvedId}`, {
        data: {
          resolvedTarget,
          settings
        }
      });
      const visualTypeInfo = this._options.visualTypes[type];
      if (!visualTypeInfo) {
        this._logger.error(`Visual type ${type} is not supported (did you provide a valid visual type?)`);
        throw new Error(`Visual type ${type} is not supported (did you provide a valid visual type?)`);
      }
      if (!(options === null || options === void 0 ? void 0 : options.isLegacy)) {
        this._logger.log(`Validating visual settings for ${type} with id ${resolvedId}`, {
          data: {
            settings
          }
        });
        if (validateSchema(settings, visualTypeInfo.schema, 'element settings', this._logger).length !== 0) {
          throw new Error(`Invalid settings provided for visual ${type} (check console warnings starting with 'Validation errors for settings')`);
        }
      } else {
        this._logger.log(`Skipping visual schema settings validation for visual ${type} with id ${resolvedId}`);
      }
      if (!isUpdatingExistingVisual && (visualTypeInfo === null || visualTypeInfo === void 0 ? void 0 : visualTypeInfo.singleton)) {
        const existingVisualsByType = this._visuals.filter(visual => visual.type === type);
        if (existingVisualsByType.length > 0) {
          this._logger.log(`Visual ${type} with id ${resolvedId} is already mounted and visual type is singleton, removing previous visual and remounting`);
          existingVisualsByType.forEach(visual => {
            this.unmountVisual(visual.id);
          });
          visualToMountOrUpdate = null;
        }
      }
      if (!visualToMountOrUpdate) {
        this._logger.log(`Creating new visual for ${type} with id ${resolvedId}`);
        const htmlElement = this._services.utils.createOrGetVisual({
          visualTarget: resolvedTarget,
          visualId: resolvedId,
          widgetName: this.widgetName,
          runtimeName: this.runtimeName,
          logger: this._logger,
          workspaceName: this._workspaceName
        });
        if (!htmlElement) {
          throw new Error(`Failed to create visual element for ${type} with id ${resolvedId}`);
        }
        const htmlContainer = this._createVisualContainer(htmlElement);
        this._logger.log(`Storing visual ${type} with id ${resolvedId}`);
        visualToMountOrUpdate = {
          id: resolvedId,
          type,
          htmlContainer,
          target: resolvedTarget,
          settings
        };
        this._visuals.push(visualToMountOrUpdate);
      }
      if (!visualToMountOrUpdate) {
        throw new Error(`Failed to create visual for ${type} with id ${resolvedId}`);
      }
      try {
        if (!this._onVisualMount(Object.assign({}, visualToMountOrUpdate))) {
          this._logger.warn(`failed to mount visual type: ${type} (mount visual) as the inherited class failed to mount it, visual html element will remain empty`);
        }
      } catch (error) {
        this._logger.error(`Failed to mount visual with type '${type}' (mount visual) due to an error in the inherited class, ${error === null || error === void 0 ? void 0 : error.message}`, {
          error
        });
      }
      return {
        id: visualToMountOrUpdate.id,
        unsubscribe: () => {
          this.unmountVisual(visualToMountOrUpdate.id);
        }
      };
    } catch (e) {
      this._logger.error(`Failed to mount visual with type '${type}' (mount visual) due to an error, ${e === null || e === void 0 ? void 0 : e.message}`, {
        error: e,
        data: {
          settings
        }
      });
      return {
        id: '',
        unsubscribe: () => {}
      };
    }
  }
}

class UnisphereLoadError extends Error {
  constructor(message, code) {
    super(message); // Pass the message to the Error constructor
    this.name = 'UnisphereLoadError'; // Set the name of the error
    this.code = code; // Set the code, defaulting to 'UNKNOWN' if none is provided
    // This line is needed to make the instanceof operator work correctly with custom errors
    Object.setPrototypeOf(this, UnisphereLoadError.prototype);
  }
}

const workspaceVersion = '1.0.0';

var anObject$c = anObject$p;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$c(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$e = fails$t;
var globalThis$f = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = globalThis$f.RegExp;

var UNSUPPORTED_Y$1 = fails$e(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
UNSUPPORTED_Y$1 || fails$e(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$e(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET};

var fails$d = fails$t;
var globalThis$e = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = globalThis$e.RegExp;

var regexpUnsupportedDotAll = fails$d(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$c = fails$t;
var globalThis$d = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis$d.RegExp;

var regexpUnsupportedNcg = fails$c(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$d = functionCall;
var uncurryThis$g = functionUncurryThis;
var toString$b = toString$d;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4;
var create$2 = objectCreate;
var getInternalState$2 = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$7 = uncurryThis$g(''.charAt);
var indexOf = uncurryThis$g(''.indexOf);
var replace$6 = uncurryThis$g(''.replace);
var stringSlice$6 = uncurryThis$g(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$d(nativeExec, re1, 'a');
  call$d(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$2(re);
    var str = toString$b(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$d(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$d(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$6(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$6(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$7(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$d(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$6(match.input, charsAdded);
        match[0] = stringSlice$6(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$d(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$2(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$l = _export;
var exec$5 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$l({ target: 'RegExp', proto: true, forced: /./.exec !== exec$5 }, {
  exec: exec$5
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$c = functionCall;
var defineBuiltIn$8 = defineBuiltIn$d;
var regexpExec$1 = regexpExec$2;
var fails$b = fails$t;
var wellKnownSymbol$9 = wellKnownSymbol$m;
var createNonEnumerableProperty = createNonEnumerableProperty$9;

var SPECIES$3 = wellKnownSymbol$9('species');
var RegExpPrototype$2 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$9(KEY);

  var DELEGATES_TO_SYMBOL = !fails$b(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$b(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype$2.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$c(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$c(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$8(String.prototype, KEY, methods[0]);
    defineBuiltIn$8(RegExpPrototype$2, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype$2[SYMBOL], 'sham', true);
};

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var call$b = functionCall;
var anObject$b = anObject$p;
var isCallable$8 = isCallable$p;
var classof$4 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$6 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$8(exec)) {
    var result = call$b(exec, R, S);
    if (result !== null) anObject$b(result);
    return result;
  }
  if (classof$4(R) === 'RegExp') return call$b(regexpExec, R, S);
  throw new $TypeError$6('RegExp#exec called on incompatible receiver');
};

var call$a = functionCall;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$a = anObject$p;
var isNullOrUndefined$2 = isNullOrUndefined$6;
var requireObjectCoercible$5 = requireObjectCoercible$9;
var sameValue = sameValue$1;
var toString$a = toString$d;
var getMethod$1 = getMethod$6;
var regExpExec$1 = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic$1('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$5(this);
      var searcher = isNullOrUndefined$2(regexp) ? undefined : getMethod$1(regexp, SEARCH);
      return searcher ? call$a(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$a(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject$a(this);
      var S = toString$a(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec$1(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

const getQueryParam = paramName => {
  const queryParams = window.location.search.substr(1);
  const paramsArray = queryParams.split('&');
  const searchParam = `${paramName}=`;
  const roomParam = paramsArray.filter(queryParam => queryParam.search(searchParam) >= 0);
  if (roomParam.length > 0) {
    return roomParam[0].substring(roomParam[0].search(searchParam) + searchParam.length);
  }
  return '';
};

var $$k = _export;
var $includes = arrayIncludes.includes;
var fails$a = fails$t;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$a(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$k({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var aCallable$6 = aCallable$e;
var toObject$2 = toObject$7;
var IndexedObject = indexedObject;
var lengthOfArrayLike$1 = lengthOfArrayLike$5;

var $TypeError$5 = TypeError;

var REDUCE_EMPTY = 'Reduce of empty array with no initial value';

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    var O = toObject$2(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike$1(O);
    aCallable$6(callbackfn);
    if (length === 0 && argumentsLength < 2) throw new $TypeError$5(REDUCE_EMPTY);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError$5(REDUCE_EMPTY);
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false)};

var fails$9 = fails$t;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$9(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

/* global Bun, Deno -- detection */
var globalThis$c = globalThis_1;
var userAgent$3 = environmentUserAgent;
var classof$3 = classofRaw$2;

var userAgentStartsWith = function (string) {
  return userAgent$3.slice(0, string.length) === string;
};

var environment = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis$c.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis$c.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof$3(globalThis$c.process) === 'process') return 'NODE';
  if (globalThis$c.window && globalThis$c.document) return 'BROWSER';
  return 'REST';
})();

var ENVIRONMENT$1 = environment;

var environmentIsNode = ENVIRONMENT$1 === 'NODE';

var $$j = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = environmentV8Version;
var IS_NODE$4 = environmentIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE$4 && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$1 = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$j({ target: 'Array', proto: true, forced: FORCED$1 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var $$i = _export;
var iterate$3 = iterate$6;
var aCallable$5 = aCallable$e;
var anObject$9 = anObject$p;
var getIteratorDirect$1 = getIteratorDirect$5;

var $TypeError$4 = TypeError;

// `Iterator.prototype.reduce` method
// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
$$i({ target: 'Iterator', proto: true, real: true }, {
  reduce: function reduce(reducer /* , initialValue */) {
    anObject$9(this);
    aCallable$5(reducer);
    var record = getIteratorDirect$1(this);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    var counter = 0;
    iterate$3(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, { IS_RECORD: true });
    if (noInitial) throw new $TypeError$4('Reduce of empty iterator with no initial value');
    return accumulator;
  }
});

var isObject$3 = isObject$e;
var classof$2 = classofRaw$2;
var wellKnownSymbol$8 = wellKnownSymbol$m;

var MATCH$1 = wellKnownSymbol$8('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$3(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$2(it) === 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError$3 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError$3("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$7 = wellKnownSymbol$m;

var MATCH = wellKnownSymbol$7('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$h = _export;
var uncurryThis$f = functionUncurryThisClause;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var toLength$1 = toLength$3;
var toString$9 = toString$d;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$4 = requireObjectCoercible$9;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

var stringSlice$5 = uncurryThis$f(''.slice);
var min$1 = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic$1('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor$1(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$h({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString$9(requireObjectCoercible$4(this));
    notARegExp$1(searchString);
    var index = toLength$1(min$1(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$9(searchString);
    return stringSlice$5(that, index, index + search.length) === search;
  }
});

// a string of all valid unicode whitespaces
var whitespaces$3 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$e = functionUncurryThis;
var requireObjectCoercible$3 = requireObjectCoercible$9;
var toString$8 = toString$d;
var whitespaces$2 = whitespaces$3;

var replace$5 = uncurryThis$e(''.replace);
var ltrim = RegExp('^[' + whitespaces$2 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$2 + '])[' + whitespaces$2 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = toString$8(requireObjectCoercible$3($this));
    if (TYPE & 1) string = replace$5(string, ltrim, '');
    if (TYPE & 2) string = replace$5(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var fails$8 = fails$t;
var whitespaces$1 = whitespaces$3;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$8(function () {
    return !!whitespaces$1[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME$1 && whitespaces$1[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$g = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$g({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

let verboseFromQueryParams = getQueryParam('unisphereVerbose') === 'true' ? 'log' : getQueryParam('unisphereVerbose') || '';
const logLevel = ['log', 'debug'].includes(verboseFromQueryParams) ? verboseFromQueryParams : 'warn';
const unisphereEnvironment = getQueryParam('unisphereEnvironment') || 'prod';
const presets = getQueryParam('unispherePresets') || null;
let resolvedPresets = presets ? presets.split(',').reduce((acc, preset) => {
  if (preset.startsWith('-')) {
    acc.deactivate.push(preset.substring(1).trim());
  } else {
    acc.activate.push(preset.trim());
  }
  return acc;
}, {
  activate: [],
  deactivate: []
}) : null;
const unisphereEnv$2 = {
  logLevel,
  verbose: verboseFromQueryParams,
  environment: unisphereEnvironment === 'dev' ? 'dev' : 'prod',
  presets: resolvedPresets
};
const getUnisphereEnv = () => unisphereEnv$2;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var getBuiltIn$8 = getBuiltIn$d;
var defineBuiltInAccessor$4 = defineBuiltInAccessor$6;
var wellKnownSymbol$6 = wellKnownSymbol$m;
var DESCRIPTORS$8 = descriptors;

var SPECIES$2 = wellKnownSymbol$6('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$8(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$8 && Constructor && !Constructor[SPECIES$2]) {
    defineBuiltInAccessor$4(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var uncurryThis$d = functionUncurryThis;
var fails$7 = fails$t;
var isCallable$7 = isCallable$p;
var classof$1 = classof$8;
var getBuiltIn$7 = getBuiltIn$d;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var construct = getBuiltIn$7('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$4 = uncurryThis$d(constructorRegExp.exec);
var INCORRECT_TO_STRING$2 = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$7(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$7(argument)) return false;
  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING$2 || !!exec$4(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$2 = !construct || fails$7(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor$1 = isConstructor$2;
var tryToString = tryToString$4;

var $TypeError$2 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor$1(argument)) return argument;
  throw new $TypeError$2(tryToString(argument) + ' is not a constructor');
};

var anObject$8 = anObject$p;
var aConstructor = aConstructor$1;
var isNullOrUndefined$1 = isNullOrUndefined$6;
var wellKnownSymbol$5 = wellKnownSymbol$m;

var SPECIES$1 = wellKnownSymbol$5('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$8(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$1(S = anObject$8(C)[SPECIES$1]) ? defaultConstructor : aConstructor(S);
};

var uncurryThis$c = functionUncurryThis;

var arraySlice$3 = uncurryThis$c([].slice);

var $TypeError$1 = TypeError;

var validateArgumentsLength$6 = function (passed, required) {
  if (passed < required) throw new $TypeError$1('Not enough arguments');
  return passed;
};

var userAgent$2 = environmentUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var environmentIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var globalThis$b = globalThis_1;
var apply$1 = functionApply;
var bind$5 = functionBindContext;
var isCallable$6 = isCallable$p;
var hasOwn$5 = hasOwnProperty_1;
var fails$6 = fails$t;
var html = html$2;
var arraySlice$2 = arraySlice$3;
var createElement = documentCreateElement$2;
var validateArgumentsLength$5 = validateArgumentsLength$6;
var IS_IOS$1 = environmentIsIos;
var IS_NODE$3 = environmentIsNode;

var set = globalThis$b.setImmediate;
var clear = globalThis$b.clearImmediate;
var process$2 = globalThis$b.process;
var Dispatch = globalThis$b.Dispatch;
var Function$1 = globalThis$b.Function;
var MessageChannel = globalThis$b.MessageChannel;
var String$1 = globalThis$b.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$6(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = globalThis$b.location;
});

var run = function (id) {
  if (hasOwn$5(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  globalThis$b.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength$5(arguments.length, 1);
    var fn = isCallable$6(handler) ? handler : Function$1(handler);
    var args = arraySlice$2(arguments, 1);
    queue$2[++counter] = function () {
      apply$1(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$5(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    globalThis$b.addEventListener &&
    isCallable$6(globalThis$b.postMessage) &&
    !globalThis$b.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$6(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    globalThis$b.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set};

var globalThis$a = globalThis_1;
var DESCRIPTORS$7 = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$2 = function (name) {
  if (!DESCRIPTORS$7) return globalThis$a[name];
  var descriptor = getOwnPropertyDescriptor(globalThis$a, name);
  return descriptor && descriptor.value;
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$1 = environmentUserAgent;

var environmentIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && typeof Pebble != 'undefined';

var userAgent = environmentUserAgent;

var environmentIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var globalThis$9 = globalThis_1;
var safeGetBuiltIn$1 = safeGetBuiltIn$2;
var bind$4 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = environmentIsIos;
var IS_IOS_PEBBLE = environmentIsIosPebble;
var IS_WEBOS_WEBKIT = environmentIsWebosWebkit;
var IS_NODE$2 = environmentIsNode;

var MutationObserver = globalThis$9.MutationObserver || globalThis$9.WebKitMutationObserver;
var document$2 = globalThis$9.document;
var process$1 = globalThis$9.process;
var Promise$1 = globalThis$9.Promise;
var microtask$1 = safeGetBuiltIn$1('queueMicrotask');
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$4(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$4(macrotask, globalThis$9);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var globalThis$8 = globalThis_1;

var promiseNativeConstructor = globalThis$8.Promise;

var globalThis$7 = globalThis_1;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$5 = isCallable$p;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$4 = wellKnownSymbol$m;
var ENVIRONMENT = environment;
var V8_VERSION = environmentV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES = wellKnownSymbol$4('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$5(globalThis$7.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$4 = aCallable$e;

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$4(resolve);
  this.reject = aCallable$4(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$f = _export;
var IS_NODE$1 = environmentIsNode;
var globalThis$6 = globalThis_1;
var call$9 = functionCall;
var defineBuiltIn$7 = defineBuiltIn$d;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$3 = setToStringTag$7;
var setSpecies = setSpecies$1;
var aCallable$3 = aCallable$e;
var isCallable$4 = isCallable$p;
var isObject$2 = isObject$e;
var anInstance$4 = anInstance$6;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule$4 = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$4.getterFor(PROMISE);
var setInternalState$4 = InternalStateModule$4.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$3 = globalThis$6.TypeError;
var document$1 = globalThis$6.document;
var process = globalThis$6.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && globalThis$6.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$2(it) && isCallable$4(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$3('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$9(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    globalThis$6.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis$6['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$9(task, globalThis$6, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE$1) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$9(task, globalThis$6, function () {
    var promise = state.facade;
    if (IS_NODE$1) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$3 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$3("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$9(then, value,
            bind$3(internalResolve, wrapper, state),
            bind$3(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$4(this, PromisePrototype);
    aCallable$3(executor);
    call$9(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$3(internalResolve, state), bind$3(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$4(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: null
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$7(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$4(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$4(onRejected) && onRejected;
    reaction.domain = IS_NODE$1 ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$3(internalResolve, state);
    this.reject = bind$3(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$4(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$7(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$9(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$$f({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag$3(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var wellKnownSymbol$3 = wellKnownSymbol$m;

var ITERATOR$2 = wellKnownSymbol$3('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$e = _export;
var call$8 = functionCall;
var aCallable$2 = aCallable$e;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$2 = iterate$6;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$e({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$2(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$2(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$8($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$d = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$6 = getBuiltIn$d;
var isCallable$3 = isCallable$p;
var defineBuiltIn$6 = defineBuiltIn$d;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$d({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$3(NativePromiseConstructor)) {
  var method = getBuiltIn$6('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$6(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$c = _export;
var call$7 = functionCall;
var aCallable$1 = aCallable$e;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate$1 = iterate$6;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$c({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate$1(iterable, function (promise) {
        call$7($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$b = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$b({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});

var anObject$7 = anObject$p;
var isObject$1 = isObject$e;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$7(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$a = _export;
var getBuiltIn$5 = getBuiltIn$d;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn$5('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$a({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

var call$6 = functionCall;
var hasOwn$4 = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn$4(R, 'flags') && isPrototypeOf(RegExpPrototype$1, R)
    ? call$6(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn$5 = defineBuiltIn$d;
var anObject$6 = anObject$p;
var $toString$2 = toString$d;
var fails$5 = fails$t;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails$5(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$5(RegExpPrototype, TO_STRING, function toString() {
    var R = anObject$6(this);
    var pattern = $toString$2(R.source);
    var flags = $toString$2(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const logger$1 = UnisphereLoggerFactory.createWorkspaceLogger('window').getOrCreateLogger('loader', 'fetch-artifact');
// Helper function to handle callbacks
const executeCallbacks = (callbacks, arg, url, type) => {
  if (callbacks.length > 0) {
    logger$1.log(`calling ${type} callbacks for ${url} (${callbacks.length} queued)`);
    callbacks.forEach(fn => {
      try {
        fn(arg);
      } catch (error) {
        logger$1.error(`error calling ${type} callback for ${url}`, {
          error
        });
      }
    });
  }
};
/**
 * Import a module with a nonce attribute for Content Security Policy compliance
 */
function importWithNonce(url, nonce) {
  return __awaiter(this, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
      logger$1.log(`Importing module with nonce from ${url}`);
      // Create a unique ID for this import operation
      const importId = `unisphere_import_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      // Create a global callback function that will be called when the import completes
      window[`${importId}_resolve`] = module => {
        logger$1.log(`Module from ${url} loaded successfully`);
        // Clean up
        delete window[`${importId}_resolve`];
        delete window[`${importId}_reject`];
        // Remove the script element
        const scriptElement = document.getElementById(importId);
        if (scriptElement) {
          scriptElement.remove();
        }
        resolve(module);
      };
      // Create a global callback function that will be called if the import fails
      window[`${importId}_reject`] = error => {
        logger$1.error(`Failed to load module from ${url}`, {
          error
        });
        // Clean up
        delete window[`${importId}_resolve`];
        delete window[`${importId}_reject`];
        // Remove the script element
        const scriptElement = document.getElementById(importId);
        if (scriptElement) {
          scriptElement.remove();
        }
        reject(error);
      };
      // Create a script element
      const script = document.createElement('script');
      script.id = importId;
      // Add nonce if provided
      if (nonce) {
        script.setAttribute('nonce', nonce);
      }
      // Set up the script content to perform the dynamic import
      script.textContent = `
      (async () => {
        try {
          const module = await import("${url}");
          try {
            window["${importId}_resolve"](module);
          } catch (error) {
            console.error('Failed to resolve module from "${url}"', { error });
          }
        } catch (error) {
          window["${importId}_reject"](error);
        }
      })();
    `;
      // Add the script to the document
      document.head.appendChild(script);
      // Set a timeout to handle cases where the script might not execute
      setTimeout(() => {
        if (window[`${importId}_resolve`]) {
          logger$1.error(`Import timeout for ${url}`);
          // The import didn't complete within the timeout
          const error = new Error(`Timeout importing module from ${url}`);
          window[`${importId}_reject`](error);
        }
      }, 30000); // 30 second timeout
    });
  });
}
function fetchArtifact(_a) {
  return __awaiter(this, arguments, void 0, function* ({
    owner,
    url,
    fetchStrategy
  }) {
    var _b;
    const {
      value: factoriesByURLS
    } = getOrCreateGlobalUnisphere('factoriesByURLS', logger$1, {});
    const normalizedUrl = url.toLowerCase();
    const cachedFactoryInfo = factoriesByURLS[normalizedUrl];
    if (cachedFactoryInfo) {
      if (cachedFactoryInfo.factoryModule) {
        logger$1.log(`using cached factory module for ${url}`);
        return {
          factoryModule: cachedFactoryInfo.factoryModule
        };
      }
      logger$1.log(`a request to fetch factory already in progress for ${url}, waiting for it to finish`);
      return new Promise((resolve, reject) => {
        cachedFactoryInfo.onFetched.push(resolve);
        cachedFactoryInfo.onError.push(reject);
      });
    }
    logger$1.log(`fetching factory module for ${url}`);
    const factory = {
      requester: owner,
      factoryModule: null,
      onFetched: [],
      onError: []
    };
    factoriesByURLS[normalizedUrl] = factory;
    try {
      // Get nonce from global config if available
      const nonce = (_b = window.kalturaGlobalConfig) === null || _b === void 0 ? void 0 : _b.scriptsNonce;
      const resolvedFetchStrategy = fetchStrategy || (nonce ? 'scripts' : 'esm');
      logger$1.log(`using fetch strategy ${resolvedFetchStrategy} for ${url}`, {
        data: {
          fetchStrategy,
          hasNonce: !!nonce,
          resolvedFetchStrategy
        }
      });
      const factoryModule = resolvedFetchStrategy === 'scripts' ? yield importWithNonce(url, nonce) : yield import(/* webpackIgnore: true */url);
      logger$1.log(`fetched factory module for ${url}, caching it`);
      factory.factoryModule = factoryModule;
      const result = {
        factoryModule: factory.factoryModule
      };
      executeCallbacks(factory.onFetched, result, url, 'onFetched');
      factory.onFetched = [];
      factory.onError = [];
      return result;
    } catch (error) {
      logger$1.log(`failed to fetch factory module for ${url}, removing from list`);
      executeCallbacks(factory.onError, error, url, 'onError');
      factory.onError = [];
      factory.onFetched = [];
      logger$1.log(`removing cached factory info for ${url} (next time it will be fetched again)`);
      delete factoriesByURLS[normalizedUrl];
      throw error;
    }
  });
}

const logger = UnisphereLoggerFactory.createWorkspaceLogger('_global_').getOrCreateLogger('loader', 'reserve-workspace-by-application');
const {
  value: loadWorkspaceIntent
} = getOrCreateGlobalUnisphere('loadWorkspaceIntent', logger, {});
const reserveWorkspaceByApplication = ({
  workspaceName,
  appId
}) => {
  const normalizedWorkspaceName = workspaceName || '';
  const normalizedUnisphereAppId = appId || '_unknown_';
  const isAllowedToLoad = !loadWorkspaceIntent[normalizedWorkspaceName] || loadWorkspaceIntent[normalizedWorkspaceName] === normalizedUnisphereAppId;
  if (!isAllowedToLoad) {
    const errorMessage = `unisphere workspace '${normalizedWorkspaceName}' is not allowed to load by app '${normalizedUnisphereAppId}'. Application '${loadWorkspaceIntent[normalizedWorkspaceName]}' already reserved this workspace (consider using the same instance loaded by '${loadWorkspaceIntent[normalizedWorkspaceName]}')`;
    logger.warn(errorMessage, {
      data: {
        workspaceName: normalizedWorkspaceName,
        appId: normalizedUnisphereAppId,
        reservedByApp: loadWorkspaceIntent[normalizedWorkspaceName]
      }
    });
    throw new UnisphereLoadError(errorMessage, 'UNISPHERE_WORKSPACE_ALREADY_EXISTS');
  }
  logger.debug(`reserving workspace for app '${normalizedUnisphereAppId}'`, {
    data: {
      workspaceName: normalizedWorkspaceName,
      appId: normalizedUnisphereAppId
    }
  });
  loadWorkspaceIntent[normalizedWorkspaceName] = normalizedUnisphereAppId;
};

const fetchAndLoadUnisphereWorkspace = unisphereWorkspaceConfig => __awaiter(void 0, void 0, void 0, function* () {
  var _a;
  const logger = UnisphereLoggerFactory.createWorkspaceLogger(unisphereWorkspaceConfig.workspaceName || '').getOrCreateLogger('loader', 'fetch-and-load-unisphere-workspace');
  reserveWorkspaceByApplication({
    workspaceName: unisphereWorkspaceConfig.workspaceName,
    appId: unisphereWorkspaceConfig.appId
  });
  const environmentLoaderUrl = `${unisphereWorkspaceConfig.serverUrl}/loader/index.esm.js`;
  logger.log('fetching environment unisphere loader', {
    data: {
      environmentLoaderUrl,
      unisphereWorkspaceConfig
    }
  });
  const {
    factoryModule: {
      loader
    }
  } = yield fetchArtifact({
    owner: '(unknown)',
    url: environmentLoaderUrl,
    fetchStrategy: (_a = unisphereWorkspaceConfig.devops) === null || _a === void 0 ? void 0 : _a.fetchStrategy
  });
  if (!loader) {
    throw new Error(`failed to load dev loader from '${environmentLoaderUrl}'`);
  }
  logger.log(`executing environment unisphere loader from '${environmentLoaderUrl}'`);
  return loader(unisphereWorkspaceConfig);
});

var $$9 = _export;
var iterate = iterate$6;
var aCallable = aCallable$e;
var anObject$5 = anObject$p;
var getIteratorDirect = getIteratorDirect$5;

// `Iterator.prototype.some` method
// https://tc39.es/ecma262/#sec-iterator.prototype.some
$$9({ target: 'Iterator', proto: true, real: true }, {
  some: function some(predicate) {
    anObject$5(this);
    aCallable(predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return iterate(record, function (value, stop) {
      if (predicate(value, counter++)) return stop();
    }, { IS_RECORD: true, INTERRUPTED: true }).stopped;
  }
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var $$8 = _export;
var call$5 = functionCall;
var isCallable$2 = isCallable$p;
var anObject$4 = anObject$p;
var toString$7 = toString$d;

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$$8({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject$4(this);
    var string = toString$7(S);
    var exec = R.exec;
    if (!isCallable$2(exec)) return call$5(nativeTest, R, string);
    var result = call$5(exec, R, string);
    if (result === null) return false;
    anObject$4(result);
    return true;
  }
});

var $$7 = _export;
var uncurryThis$b = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$2 = requireObjectCoercible$9;
var toString$6 = toString$d;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf$1 = uncurryThis$b(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$7({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString$6(requireObjectCoercible$2(this)),
      toString$6(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var uncurryThis$a = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
var toString$5 = toString$d;
var requireObjectCoercible$1 = requireObjectCoercible$9;

var charAt$6 = uncurryThis$a(''.charAt);
var charCodeAt$1 = uncurryThis$a(''.charCodeAt);
var stringSlice$4 = uncurryThis$a(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$5(requireObjectCoercible$1($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$6(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$4(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$5 = stringMultibyte.charAt;
var toString$4 = toString$d;
var InternalStateModule$3 = internalState;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$4;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$3 = InternalStateModule$3.set;
var getInternalState$1 = InternalStateModule$3.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$3(this, {
    type: STRING_ITERATOR,
    string: toString$4(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject$1(undefined, true);
  point = charAt$5(string, index);
  state.index += point.length;
  return createIterResultObject$1(point, false);
});

var fails$4 = fails$t;
var wellKnownSymbol$2 = wellKnownSymbol$m;
var DESCRIPTORS$6 = descriptors;
var IS_PURE = isPure;

var ITERATOR$1 = wellKnownSymbol$2('iterator');

var urlConstructorDetection = !fails$4(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'https://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS$6))
    || !params.sort
    || url.href !== 'https://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('https://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('https://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('https://x', undefined).host !== 'x';
});

var bind$2 = functionBindContext;
var call$4 = functionCall;
var toObject$1 = toObject$7;
var callWithSafeIterationClosing = callWithSafeIterationClosing$2;
var isArrayIteratorMethod = isArrayIteratorMethod$2;
var isConstructor = isConstructor$2;
var lengthOfArrayLike = lengthOfArrayLike$5;
var createProperty = createProperty$2;
var getIterator$1 = getIterator$3;
var getIteratorMethod$1 = getIteratorMethod$4;

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$1(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind$2(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod$1(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    result = IS_CONSTRUCTOR ? new this() : [];
    iterator = getIterator$1(O, iteratorMethod);
    next = iterator.next;
    for (;!(step = call$4(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis$9 = functionUncurryThis;

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError$1 = RangeError;
var exec$3 = uncurryThis$9(regexSeparators.exec);
var floor$3 = Math.floor;
var fromCharCode$3 = String.fromCharCode;
var charCodeAt = uncurryThis$9(''.charCodeAt);
var join$3 = uncurryThis$9([].join);
var push$4 = uncurryThis$9([].push);
var replace$4 = uncurryThis$9(''.replace);
var split$2 = uncurryThis$9(''.split);
var toLowerCase$1 = uncurryThis$9(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
        push$4(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$4(output, value);
        counter--;
      }
    } else {
      push$4(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$3(delta / damp) : delta >> 1;
  delta += floor$3(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$3(delta / baseMinusTMin);
    k += base;
  }
  return floor$3(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push$4(output, fromCharCode$3(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push$4(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$3((maxInt - delta) / handledCPCountPlusOne)) {
      throw new $RangeError$1(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw new $RangeError$1(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$4(output, fromCharCode$3(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$3(qMinusT / baseMinusT);
          k += base;
        }

        push$4(output, fromCharCode$3(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join$3(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$2(replace$4(toLowerCase$1(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$4(encoded, exec$3(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join$3(encoded, '.');
};

var $$6 = _export;
var uncurryThis$8 = functionUncurryThis;
var toAbsoluteIndex = toAbsoluteIndex$2;

var $RangeError = RangeError;
var fromCharCode$2 = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join$2 = uncurryThis$8([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$$6({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError(code + ' is not a valid code point');
      elements[i] = code < 0x10000
        ? fromCharCode$2(code)
        : fromCharCode$2(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join$2(elements, '');
  }
});

var arraySlice$1 = arraySlice$3;

var floor$2 = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor$2(length / 2);
    var left = sort(arraySlice$1(array, 0, middle), comparefn);
    var right = sort(arraySlice$1(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

var arraySort$1 = sort;

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`


var $$5 = _export;
var globalThis$5 = globalThis_1;
var safeGetBuiltIn = safeGetBuiltIn$2;
var getBuiltIn$4 = getBuiltIn$d;
var call$3 = functionCall;
var uncurryThis$7 = functionUncurryThis;
var DESCRIPTORS$5 = descriptors;
var USE_NATIVE_URL$1 = urlConstructorDetection;
var defineBuiltIn$4 = defineBuiltIn$d;
var defineBuiltInAccessor$3 = defineBuiltInAccessor$6;
var defineBuiltIns = defineBuiltIns$2;
var setToStringTag$2 = setToStringTag$7;
var createIteratorConstructor = iteratorCreateConstructor;
var InternalStateModule$2 = internalState;
var anInstance$3 = anInstance$6;
var isCallable$1 = isCallable$p;
var hasOwn$3 = hasOwnProperty_1;
var bind$1 = functionBindContext;
var classof = classof$8;
var anObject$3 = anObject$p;
var isObject = isObject$e;
var $toString$1 = toString$d;
var create$1 = objectCreate;
var createPropertyDescriptor$2 = createPropertyDescriptor$8;
var getIterator = getIterator$3;
var getIteratorMethod = getIteratorMethod$4;
var createIterResultObject = createIterResultObject$4;
var validateArgumentsLength$4 = validateArgumentsLength$6;
var wellKnownSymbol$1 = wellKnownSymbol$m;
var arraySort = arraySort$1;

var ITERATOR = wellKnownSymbol$1('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$2 = InternalStateModule$2.set;
var getInternalParamsState = InternalStateModule$2.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule$2.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var TypeError$2 = globalThis$5.TypeError;
var encodeURIComponent$1 = globalThis$5.encodeURIComponent;
var fromCharCode$1 = String.fromCharCode;
var fromCodePoint = getBuiltIn$4('String', 'fromCodePoint');
var $parseInt = parseInt;
var charAt$4 = uncurryThis$7(''.charAt);
var join$1 = uncurryThis$7([].join);
var push$3 = uncurryThis$7([].push);
var replace$3 = uncurryThis$7(''.replace);
var shift$1 = uncurryThis$7([].shift);
var splice = uncurryThis$7([].splice);
var split$1 = uncurryThis$7(''.split);
var stringSlice$3 = uncurryThis$7(''.slice);
var exec$2 = uncurryThis$7(/./.exec);

var plus = /\+/g;
var FALLBACK_REPLACER = '\uFFFD';
var VALID_HEX = /^[0-9a-f]+$/i;

var parseHexOctet = function (string, start) {
  var substr = stringSlice$3(string, start, start + 2);
  if (!exec$2(VALID_HEX, substr)) return NaN;

  return $parseInt(substr, 16);
};

var getLeadingOnes = function (octet) {
  var count = 0;
  for (var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1) {
    count++;
  }
  return count;
};

var utf8Decode = function (octets) {
  var codePoint = null;

  switch (octets.length) {
    case 1:
      codePoint = octets[0];
      break;
    case 2:
      codePoint = (octets[0] & 0x1F) << 6 | (octets[1] & 0x3F);
      break;
    case 3:
      codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | (octets[2] & 0x3F);
      break;
    case 4:
      codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | (octets[3] & 0x3F);
      break;
  }

  return codePoint > 0x10FFFF ? null : codePoint;
};

var decode = function (input) {
  input = replace$3(input, plus, ' ');
  var length = input.length;
  var result = '';
  var i = 0;

  while (i < length) {
    var decodedChar = charAt$4(input, i);

    if (decodedChar === '%') {
      if (charAt$4(input, i + 1) === '%' || i + 3 > length) {
        result += '%';
        i++;
        continue;
      }

      var octet = parseHexOctet(input, i + 1);

      // eslint-disable-next-line no-self-compare -- NaN check
      if (octet !== octet) {
        result += decodedChar;
        i++;
        continue;
      }

      i += 2;
      var byteSequenceLength = getLeadingOnes(octet);

      if (byteSequenceLength === 0) {
        decodedChar = fromCharCode$1(octet);
      } else {
        if (byteSequenceLength === 1 || byteSequenceLength > 4) {
          result += FALLBACK_REPLACER;
          i++;
          continue;
        }

        var octets = [octet];
        var sequenceIndex = 1;

        while (sequenceIndex < byteSequenceLength) {
          i++;
          if (i + 3 > length || charAt$4(input, i) !== '%') break;

          var nextByte = parseHexOctet(input, i + 1);

          // eslint-disable-next-line no-self-compare -- NaN check
          if (nextByte !== nextByte) {
            i += 3;
            break;
          }
          if (nextByte > 191 || nextByte < 128) break;

          push$3(octets, nextByte);
          i += 2;
          sequenceIndex++;
        }

        if (octets.length !== byteSequenceLength) {
          result += FALLBACK_REPLACER;
          continue;
        }

        var codePoint = utf8Decode(octets);
        if (codePoint === null) {
          result += FALLBACK_REPLACER;
        } else {
          decodedChar = fromCodePoint(codePoint);
        }
      }
    }

    result += decodedChar;
    i++;
  }

  return result;
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$3(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState$2(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt$4(init, 0) === '?' ? stringSlice$3(init, 1) : init : $toString$1(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call$3(next, iterator)).done) {
        entryIterator = getIterator(anObject$3(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call$3(entryNext, entryIterator)).done ||
          (second = call$3(entryNext, entryIterator)).done ||
          !call$3(entryNext, entryIterator).done
        ) throw new TypeError$2('Expected sequence with length 2');
        push$3(entries, { key: $toString$1(first.value), value: $toString$1(second.value) });
      }
    } else for (var key in object) if (hasOwn$3(object, key)) {
      push$3(entries, { key: key, value: $toString$1(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split$1(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split$1(attribute, '=');
          push$3(entries, {
            key: decode(shift$1(entry)),
            value: decode(join$1(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$3(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join$1(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance$3(this, URLSearchParamsPrototype$3);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState$2(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS$5) this.size = state.entries.length;
};

var URLSearchParamsPrototype$3 = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype$3, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$4(arguments.length, 2);
    push$3(state.entries, { key: $toString$1(name), value: $toString$1(value) });
    if (!DESCRIPTORS$5) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength$4(arguments.length, 1);
    var entries = state.entries;
    var key = $toString$1(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString$1($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS$5) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength$4(arguments.length, 1);
    var key = $toString$1(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength$4(arguments.length, 1);
    var key = $toString$1(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$3(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength$4(arguments.length, 1);
    var key = $toString$1(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString$1($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$4(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString$1(name);
    var val = $toString$1(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$3(entries, { key: key, value: val });
    if (!DESCRIPTORS$5) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind$1(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn$4(URLSearchParamsPrototype$3, ITERATOR, URLSearchParamsPrototype$3.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn$4(URLSearchParamsPrototype$3, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS$5) defineBuiltInAccessor$3(URLSearchParamsPrototype$3, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag$2(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$5({ global: true, constructor: true, forced: !USE_NATIVE_URL$1 }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL$1 && isCallable$1(Headers)) {
  var headersHas = uncurryThis$7(HeadersPrototype.has);
  var headersSet = uncurryThis$7(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create$1(init, {
          body: createPropertyDescriptor$2(0, $toString$1(body)),
          headers: createPropertyDescriptor$2(0, headers)
        });
      }
    } return init;
  };

  if (isCallable$1(nativeFetch)) {
    $$5({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable$1(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance$3(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$5({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$4 = _export;
var DESCRIPTORS$4 = descriptors;
var USE_NATIVE_URL = urlConstructorDetection;
var globalThis$4 = globalThis_1;
var bind = functionBindContext;
var uncurryThis$6 = functionUncurryThis;
var defineBuiltIn$3 = defineBuiltIn$d;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$6;
var anInstance$2 = anInstance$6;
var hasOwn$2 = hasOwnProperty_1;
var assign = objectAssign;
var arrayFrom = arrayFrom$1;
var arraySlice = arraySlice$3;
var codeAt = stringMultibyte.codeAt;
var toASCII = stringPunycodeToAscii;
var $toString = toString$d;
var setToStringTag$1 = setToStringTag$7;
var validateArgumentsLength$3 = validateArgumentsLength$6;
var URLSearchParamsModule = web_urlSearchParams_constructor;
var InternalStateModule$1 = internalState;

var setInternalState$1 = InternalStateModule$1.set;
var getInternalURLState = InternalStateModule$1.getterFor('URL');
var URLSearchParams$1 = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = globalThis$4.URL;
var TypeError$1 = globalThis$4.TypeError;
var parseInt$1 = globalThis$4.parseInt;
var floor$1 = Math.floor;
var pow = Math.pow;
var charAt$3 = uncurryThis$6(''.charAt);
var exec$1 = uncurryThis$6(/./.exec);
var join = uncurryThis$6([].join);
var numberToString = uncurryThis$6(1.0.toString);
var pop = uncurryThis$6([].pop);
var push$2 = uncurryThis$6([].push);
var replace$2 = uncurryThis$6(''.replace);
var shift = uncurryThis$6([].shift);
var split = uncurryThis$6(''.split);
var stringSlice$2 = uncurryThis$6(''.slice);
var toLowerCase = uncurryThis$6(''.toLowerCase);
var unshift = uncurryThis$6([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part === '') return input;
    radix = 10;
    if (part.length > 1 && charAt$3(part, 0) === '0') {
      radix = exec$1(HEX_START, part) ? 16 : 8;
      part = stringSlice$2(part, radix === 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec$1(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
      number = parseInt$1(part, radix);
    }
    push$2(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index === partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt$3(input, pointer);
  };

  if (chr() === ':') {
    if (charAt$3(input, 1) !== ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8) return;
    if (chr() === ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec$1(HEX, chr())) {
      value = value * 16 + parseInt$1(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === '.') {
      if (length === 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec$1(DIGIT, chr())) return;
        while (exec$1(DIGIT, chr())) {
          number = parseInt$1(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece === 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
      }
      if (numbersSeen !== 4) return;
      break;
    } else if (chr() === ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  return currLength > maxLength ? currStart : maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;

  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor$1(host / 256);
    }
    return join(result, '.');
  }

  // ipv6
  if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  }

  return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn$2(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length === 2 && exec$1(ALPHA, charAt$3(string, 0))
    && ((second = charAt$3(string, 1)) === ':' || (!normalized && second === '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice$2(string, 0, 2)) && (
    string.length === 2 ||
    ((third = charAt$3(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw new TypeError$1(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw new TypeError$1(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$2(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace$2(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace$2(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec$1(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec$1(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
            buffer += toLowerCase(chr);
          } else if (chr === ':') {
            if (stateOverride && (
              (url.isSpecial() !== hasOwn$2(specialSchemes, buffer)) ||
              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme === 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme === 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$2(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr === '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme === 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === '/' && codePoints[pointer + 1] === '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr === '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr === EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr === '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== '/' || charAt$3(buffer, pointer + 1) !== '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== '/' && chr !== '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr === '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer === '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr === ':' && !seenBracket) {
            if (buffer === '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride === HOSTNAME) return;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer === '') return INVALID_HOST;
            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr === '[') seenBracket = true;
            else if (chr === ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec$1(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer !== '') {
              var port = parseInt$1(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr === '/' || chr === '\\') state = FILE_SLASH;
          else if (base && base.scheme === 'file') {
            switch (chr) {
              case EOF:
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                break;
              case '?':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = '';
                state = QUERY;
                break;
              case '#':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
                break;
              default:
                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                  url.host = base.host;
                  url.path = arraySlice(base.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr === '/' || chr === '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push$2(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host === 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== '/' && chr !== '\\') continue;
          } else if (!stateOverride && chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== '/') continue;
          } break;

        case PATH:
          if (
            chr === EOF || chr === '/' ||
            (chr === '\\' && url.isSpecial()) ||
            (!stateOverride && (chr === '?' || chr === '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push$2(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push$2(url.path, '');
              }
            } else {
              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt$3(buffer, 0) + ':'; // normalize windows drive letter
              }
              push$2(url.path, buffer);
            }
            buffer = '';
            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr === '?') {
              url.query = '';
              state = QUERY;
            } else if (chr === '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            if (chr === "'" && url.isSpecial()) url.query += '%27';
            else if (chr === '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt$3(input, 0) === '[') {
      if (charAt$3(input, input.length - 1) !== ']') return INVALID_HOST;
      result = parseIPv6(stringSlice$2(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec$1(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec$1(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username !== '' || this.password !== '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn$2(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme === 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw new TypeError$1(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme === 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme === 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port === '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search === '') {
      this.query = null;
    } else {
      if (charAt$3(search, 0) === '?') search = stringSlice$2(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash === '') {
      this.fragment = null;
      return;
    }
    if (charAt$3(hash, 0) === '#') hash = stringSlice$2(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance$2(this, URLPrototype);
  var base = validateArgumentsLength$3(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState$1(that, new URLState(url, false, base));
  if (!DESCRIPTORS$4) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS$4) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor$2(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor$2(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor$2(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor$2(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor$2(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor$2(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor$2(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor$2(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor$2(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor$2(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor$2(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor$2(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn$3(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn$3(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn$3(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn$3(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag$1(URLConstructor, 'URL');

$$4({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS$4 }, {
  URL: URLConstructor
});

var $$3 = _export;
var call$2 = functionCall;

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$$3({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return call$2(URL.prototype.toString, this);
  }
});

var defineBuiltIn$2 = defineBuiltIn$d;
var uncurryThis$5 = functionUncurryThis;
var toString$3 = toString$d;
var validateArgumentsLength$2 = validateArgumentsLength$6;

var $URLSearchParams$1 = URLSearchParams;
var URLSearchParamsPrototype$2 = $URLSearchParams$1.prototype;
var append = uncurryThis$5(URLSearchParamsPrototype$2.append);
var $delete = uncurryThis$5(URLSearchParamsPrototype$2['delete']);
var forEach$1 = uncurryThis$5(URLSearchParamsPrototype$2.forEach);
var push$1 = uncurryThis$5([].push);
var params$1 = new $URLSearchParams$1('a=1&a=2&b=3');

params$1['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params$1['delete']('b', undefined);

if (params$1 + '' !== 'a=2') {
  defineBuiltIn$2(URLSearchParamsPrototype$2, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach$1(this, function (v, k) { // also validates `this`
      push$1(entries, { key: k, value: v });
    });
    validateArgumentsLength$2(length, 1);
    var key = toString$3(name);
    var value = toString$3($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}

var defineBuiltIn$1 = defineBuiltIn$d;
var uncurryThis$4 = functionUncurryThis;
var toString$2 = toString$d;
var validateArgumentsLength$1 = validateArgumentsLength$6;

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype$1 = $URLSearchParams.prototype;
var getAll = uncurryThis$4(URLSearchParamsPrototype$1.getAll);
var $has = uncurryThis$4(URLSearchParamsPrototype$1.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn$1(URLSearchParamsPrototype$1, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength$1(length, 1);
    var value = toString$2($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}

var DESCRIPTORS$3 = descriptors;
var uncurryThis$3 = functionUncurryThis;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$6;

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis$3(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS$3 && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor$1(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}

var charAt$2 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$2(S, index).length : 1);
};

var uncurryThis$2 = functionUncurryThis;
var toObject = toObject$7;

var floor = Math.floor;
var charAt$1 = uncurryThis$2(''.charAt);
var replace$1 = uncurryThis$2(''.replace);
var stringSlice$1 = uncurryThis$2(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$1(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$1(ch, 1) : captures[f - 1] + charAt$1(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var apply = functionApply;
var call$1 = functionCall;
var uncurryThis$1 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails$3 = fails$t;
var anObject$2 = anObject$p;
var isCallable = isCallable$p;
var isNullOrUndefined = isNullOrUndefined$6;
var toIntegerOrInfinity = toIntegerOrInfinity$4;
var toLength = toLength$3;
var toString$1 = toString$d;
var requireObjectCoercible = requireObjectCoercible$9;
var advanceStringIndex = advanceStringIndex$1;
var getMethod = getMethod$6;
var getSubstitution = getSubstitution$1;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol = wellKnownSymbol$m;

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis$1([].concat);
var push = uncurryThis$1([].push);
var stringIndexOf = uncurryThis$1(''.indexOf);
var stringSlice = uncurryThis$1(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$3(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call$1(replacer, searchValue, O, replaceValue)
        : call$1(nativeReplace, toString$1(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$2(this);
      var S = toString$1(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString$1(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString$1(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$1(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString$1(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var commonAlphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
var base64Alphabet = commonAlphabet + '+/';
var base64UrlAlphabet = commonAlphabet + '-_';

var inverse = function (characters) {
  // TODO: use `Object.create(null)` in `core-js@4`
  var result = {};
  var index = 0;
  for (; index < 64; index++) result[characters.charAt(index)] = index;
  return result;
};

var base64Map = {
  c2i: inverse(base64Alphabet),
  c2iUrl: inverse(base64UrlAlphabet)
};

var $$2 = _export;
var globalThis$3 = globalThis_1;
var getBuiltIn$3 = getBuiltIn$d;
var uncurryThis = functionUncurryThis;
var call = functionCall;
var fails$2 = fails$t;
var toString = toString$d;
var validateArgumentsLength = validateArgumentsLength$6;
var c2i = base64Map.c2i;

var disallowed = /[^\d+/a-z]/i;
var whitespaces = /[\t\n\f\r ]+/g;
var finalEq = /[=]{1,2}$/;

var $atob = getBuiltIn$3('atob');
var fromCharCode = String.fromCharCode;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var exec = uncurryThis(disallowed.exec);

var BASIC = !!$atob && !fails$2(function () {
  return $atob('aGk=') !== 'hi';
});

var NO_SPACES_IGNORE = BASIC && fails$2(function () {
  return $atob(' ') !== '';
});

var NO_ENCODING_CHECK = BASIC && !fails$2(function () {
  $atob('a');
});

var NO_ARG_RECEIVING_CHECK = BASIC && !fails$2(function () {
  $atob();
});

var WRONG_ARITY = BASIC && $atob.length !== 1;

var FORCED = !BASIC || NO_SPACES_IGNORE || NO_ENCODING_CHECK || NO_ARG_RECEIVING_CHECK || WRONG_ARITY;

// `atob` method
// https://html.spec.whatwg.org/multipage/webappapis.html#dom-atob
$$2({ global: true, bind: true, enumerable: true, forced: FORCED }, {
  atob: function atob(data) {
    validateArgumentsLength(arguments.length, 1);
    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
    if (BASIC && !NO_SPACES_IGNORE && !NO_ENCODING_CHECK) return call($atob, globalThis$3, data);
    var string = replace(toString(data), whitespaces, '');
    var output = '';
    var position = 0;
    var bc = 0;
    var length, chr, bs;
    if (string.length % 4 === 0) {
      string = replace(string, finalEq, '');
    }
    length = string.length;
    if (length % 4 === 1 || exec(disallowed, string)) {
      throw new (getBuiltIn$3('DOMException'))('The string is not correctly encoded', 'InvalidCharacterError');
    }
    while (position < length) {
      chr = charAt(string, position++);
      bs = bc % 4 ? bs * 64 + c2i[chr] : c2i[chr];
      if (bc++ % 4) output += fromCharCode(255 & bs >> (-2 * bc & 6));
    } return output;
  }
});

var globalThis$2 = globalThis_1;
var IS_NODE = environmentIsNode;

var getBuiltInNodeModule$1 = function (name) {
  if (IS_NODE) {
    try {
      return globalThis$2.process.getBuiltinModule(name);
    } catch (error) { /* empty */ }
    try {
      // eslint-disable-next-line no-new-func -- safe
      return Function('return require("' + name + '")')();
    } catch (error) { /* empty */ }
  }
};

var DESCRIPTORS$2 = descriptors;
var fails$1 = fails$t;
var anObject$1 = anObject$p;
var normalizeStringArgument$2 = normalizeStringArgument$4;

var nativeErrorToString = Error.prototype.toString;

var INCORRECT_TO_STRING$1 = fails$1(function () {
  if (DESCRIPTORS$2) {
    // Chrome 32- incorrectly call accessor
    // eslint-disable-next-line es/no-object-create, es/no-object-defineproperty -- safe
    var object = Object.create(Object.defineProperty({}, 'name', { get: function () {
      return this === object;
    } }));
    if (nativeErrorToString.call(object) !== 'true') return true;
  }
  // FF10- does not properly handle non-strings
  return nativeErrorToString.call({ message: 1, name: 2 }) !== '2: 1'
    // IE8 does not properly handle defaults
    || nativeErrorToString.call({}) !== 'Error';
});

var errorToString$1 = INCORRECT_TO_STRING$1 ? function toString() {
  var O = anObject$1(this);
  var name = normalizeStringArgument$2(O.name, 'Error');
  var message = normalizeStringArgument$2(O.message);
  return !name ? message : !message ? name : name + ': ' + message;
} : nativeErrorToString;

var domExceptionConstants = {
  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
};

var $$1 = _export;
var getBuiltIn$2 = getBuiltIn$d;
var getBuiltInNodeModule = getBuiltInNodeModule$1;
var fails = fails$t;
var create = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$8;
var defineProperty$1 = objectDefineProperty.f;
var defineBuiltIn = defineBuiltIn$d;
var defineBuiltInAccessor = defineBuiltInAccessor$6;
var hasOwn$1 = hasOwnProperty_1;
var anInstance$1 = anInstance$6;
var anObject = anObject$p;
var errorToString = errorToString$1;
var normalizeStringArgument$1 = normalizeStringArgument$4;
var DOMExceptionConstants$1 = domExceptionConstants;
var clearErrorStack$1 = errorStackClear;
var InternalStateModule = internalState;
var DESCRIPTORS$1 = descriptors;

var DOM_EXCEPTION$2 = 'DOMException';
var DATA_CLONE_ERR = 'DATA_CLONE_ERR';
var Error$2 = getBuiltIn$2('Error');
// NodeJS < 17.0 does not expose `DOMException` to global
var NativeDOMException$1 = getBuiltIn$2(DOM_EXCEPTION$2) || (function () {
  try {
    // NodeJS < 15.0 does not expose `MessageChannel` to global
    var MessageChannel = getBuiltIn$2('MessageChannel') || getBuiltInNodeModule('worker_threads').MessageChannel;
    // eslint-disable-next-line es/no-weak-map, unicorn/require-post-message-target-origin -- safe
    new MessageChannel().port1.postMessage(new WeakMap());
  } catch (error) {
    if (error.name === DATA_CLONE_ERR && error.code === 25) return error.constructor;
  }
})();
var NativeDOMExceptionPrototype = NativeDOMException$1 && NativeDOMException$1.prototype;
var ErrorPrototype = Error$2.prototype;
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(DOM_EXCEPTION$2);
var HAS_STACK = 'stack' in new Error$2(DOM_EXCEPTION$2);

var codeFor = function (name) {
  return hasOwn$1(DOMExceptionConstants$1, name) && DOMExceptionConstants$1[name].m ? DOMExceptionConstants$1[name].c : 0;
};

var $DOMException$1 = function DOMException() {
  anInstance$1(this, DOMExceptionPrototype$1);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument$1(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument$1(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var code = codeFor(name);
  setInternalState(this, {
    type: DOM_EXCEPTION$2,
    name: name,
    message: message,
    code: code
  });
  if (!DESCRIPTORS$1) {
    this.name = name;
    this.message = message;
    this.code = code;
  }
  if (HAS_STACK) {
    var error = new Error$2(message);
    error.name = DOM_EXCEPTION$2;
    defineProperty$1(this, 'stack', createPropertyDescriptor$1(1, clearErrorStack$1(error.stack, 1)));
  }
};

var DOMExceptionPrototype$1 = $DOMException$1.prototype = create(ErrorPrototype);

var createGetterDescriptor = function (get) {
  return { enumerable: true, configurable: true, get: get };
};

var getterFor = function (key) {
  return createGetterDescriptor(function () {
    return getInternalState(this)[key];
  });
};

if (DESCRIPTORS$1) {
  // `DOMException.prototype.code` getter
  defineBuiltInAccessor(DOMExceptionPrototype$1, 'code', getterFor('code'));
  // `DOMException.prototype.message` getter
  defineBuiltInAccessor(DOMExceptionPrototype$1, 'message', getterFor('message'));
  // `DOMException.prototype.name` getter
  defineBuiltInAccessor(DOMExceptionPrototype$1, 'name', getterFor('name'));
}

defineProperty$1(DOMExceptionPrototype$1, 'constructor', createPropertyDescriptor$1(1, $DOMException$1));

// FF36- DOMException is a function, but can't be constructed
var INCORRECT_CONSTRUCTOR = fails(function () {
  return !(new NativeDOMException$1() instanceof Error$2);
});

// Safari 10.1 / Chrome 32- / IE8- DOMException.prototype.toString bugs
var INCORRECT_TO_STRING = INCORRECT_CONSTRUCTOR || fails(function () {
  return ErrorPrototype.toString !== errorToString || String(new NativeDOMException$1(1, 2)) !== '2: 1';
});

// Deno 1.6.3- DOMException.prototype.code just missed
var INCORRECT_CODE = INCORRECT_CONSTRUCTOR || fails(function () {
  return new NativeDOMException$1(1, 'DataCloneError').code !== 25;
});

// Deno 1.6.3- DOMException constants just missed
INCORRECT_CONSTRUCTOR
  || NativeDOMException$1[DATA_CLONE_ERR] !== 25
  || NativeDOMExceptionPrototype[DATA_CLONE_ERR] !== 25;

var FORCED_CONSTRUCTOR$1 = INCORRECT_CONSTRUCTOR;

// `DOMException` constructor
// https://webidl.spec.whatwg.org/#idl-DOMException
$$1({ global: true, constructor: true, forced: FORCED_CONSTRUCTOR$1 }, {
  DOMException: FORCED_CONSTRUCTOR$1 ? $DOMException$1 : NativeDOMException$1
});

var PolyfilledDOMException$1 = getBuiltIn$2(DOM_EXCEPTION$2);
var PolyfilledDOMExceptionPrototype$1 = PolyfilledDOMException$1.prototype;

if (INCORRECT_TO_STRING && (NativeDOMException$1 === PolyfilledDOMException$1)) {
  defineBuiltIn(PolyfilledDOMExceptionPrototype$1, 'toString', errorToString);
}

if (INCORRECT_CODE && DESCRIPTORS$1 && NativeDOMException$1 === PolyfilledDOMException$1) {
  defineBuiltInAccessor(PolyfilledDOMExceptionPrototype$1, 'code', createGetterDescriptor(function () {
    return codeFor(anObject(this).name);
  }));
}

// `DOMException` constants
for (var key$1 in DOMExceptionConstants$1) if (hasOwn$1(DOMExceptionConstants$1, key$1)) {
  var constant$1 = DOMExceptionConstants$1[key$1];
  var constantName$1 = constant$1.s;
  var descriptor$1 = createPropertyDescriptor$1(6, constant$1.c);
  if (!hasOwn$1(PolyfilledDOMException$1, constantName$1)) {
    defineProperty$1(PolyfilledDOMException$1, constantName$1, descriptor$1);
  }
  if (!hasOwn$1(PolyfilledDOMExceptionPrototype$1, constantName$1)) {
    defineProperty$1(PolyfilledDOMExceptionPrototype$1, constantName$1, descriptor$1);
  }
}

var $ = _export;
var globalThis$1 = globalThis_1;
var getBuiltIn$1 = getBuiltIn$d;
var createPropertyDescriptor = createPropertyDescriptor$8;
var defineProperty = objectDefineProperty.f;
var hasOwn = hasOwnProperty_1;
var anInstance = anInstance$6;
var inheritIfRequired = inheritIfRequired$2;
var normalizeStringArgument = normalizeStringArgument$4;
var DOMExceptionConstants = domExceptionConstants;
var clearErrorStack = errorStackClear;
var DESCRIPTORS = descriptors;

var DOM_EXCEPTION$1 = 'DOMException';
var Error$1 = getBuiltIn$1('Error');
var NativeDOMException = getBuiltIn$1(DOM_EXCEPTION$1);

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = new Error$1(message);
  error.name = DOM_EXCEPTION$1;
  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};

var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;

var ERROR_HAS_STACK = 'stack' in new Error$1(DOM_EXCEPTION$1);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(globalThis$1, DOM_EXCEPTION$1);

// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399
var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);

var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
$({ global: true, constructor: true, forced: FORCED_CONSTRUCTOR }, { // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn$1(DOM_EXCEPTION$1);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  {
    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }

  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
    var constant = DOMExceptionConstants[key];
    var constantName = constant.s;
    if (!hasOwn(PolyfilledDOMException, constantName)) {
      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
    }
  }
}

var getBuiltIn = getBuiltIn$d;
var setToStringTag = setToStringTag$7;

var DOM_EXCEPTION = 'DOMException';

// `DOMException.prototype[@@toStringTag]` property
setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);

let cachedRuntimeOverrides$1 = null;
const getAllEnvManifestOverrides = (envManifest, logger) => {
  if (cachedRuntimeOverrides$1) {
    return cachedRuntimeOverrides$1;
  }
  const allowStorageOverridesRule = envManifest.rules.find(rule => rule.type === 'allow-storage-overrides-of-runtimes');
  const allowExternalOverrides = envManifest.rules.some(rule => rule.type === 'allow-external-overrides-of-runtimes');
  let queryParamsRuntimeOverrides = null;
  let storageRuntimeOverrides = null;
  let windowRuntimeOverrides = null;
  if ((allowStorageOverridesRule === null || allowStorageOverridesRule === void 0 ? void 0 : allowStorageOverridesRule.storageType) === 'localStorage') {
    try {
      logger === null || logger === void 0 ? void 0 : logger.log(`loading dev overrides from browser local storage`);
      const localStorageAsString = (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('unisphere.runtime.overrides')) || null;
      if (localStorageAsString) {
        logger === null || logger === void 0 ? void 0 : logger.log(`using dev overrides from browser local storage`);
        storageRuntimeOverrides = JSON.parse(localStorageAsString);
        if (!isRuntimeOverrides(storageRuntimeOverrides, logger)) {
          logger === null || logger === void 0 ? void 0 : logger.warn(`invalid dev overrides provided in browser local storage, ignore local storage dev overrides`, {
            data: {
              result: storageRuntimeOverrides
            }
          });
          storageRuntimeOverrides = null;
        }
      }
    } catch (error) {
      storageRuntimeOverrides = null;
      logger === null || logger === void 0 ? void 0 : logger.warn(`failed to get unisphereRuntimeOverrides from browser local storage`, {
        data: {
          error
        }
      });
    }
  }
  if ((allowStorageOverridesRule === null || allowStorageOverridesRule === void 0 ? void 0 : allowStorageOverridesRule.storageType) === 'sessionStorage') {
    try {
      logger === null || logger === void 0 ? void 0 : logger.log(`loading dev overrides from browser sessionStorage`);
      const sessionStorageAsString = (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem('unisphere.runtime.overrides')) || null;
      if (sessionStorageAsString) {
        logger === null || logger === void 0 ? void 0 : logger.log(`using dev overrides from browser sessionStorage`);
        storageRuntimeOverrides = JSON.parse(sessionStorageAsString);
        if (!isRuntimeOverrides(storageRuntimeOverrides, logger)) {
          logger === null || logger === void 0 ? void 0 : logger.warn(`invalid dev overrides provided in browser sessionStorage, ignore sessionStorage dev overrides`, {
            data: {
              result: storageRuntimeOverrides
            }
          });
          storageRuntimeOverrides = null;
        }
      }
    } catch (error) {
      storageRuntimeOverrides = null;
      logger === null || logger === void 0 ? void 0 : logger.warn(`failed to get unisphereRuntimeOverrides from browser sessionStorage`, {
        data: {
          error
        }
      });
    }
  }
  if (allowExternalOverrides) {
    try {
      const windowAsString = window === null || window === void 0 ? void 0 : window.unisphereRuntimeOverrides;
      if (windowAsString) {
        windowRuntimeOverrides = JSON.parse(window.atob(windowAsString.replace(/%3[dD]/g, '=')));
        if (!isRuntimeOverrides(windowRuntimeOverrides, logger)) {
          logger === null || logger === void 0 ? void 0 : logger.warn(`invalid dev overrides provided in window, ignore window dev overrides`, {
            data: {
              result: windowRuntimeOverrides
            }
          });
          windowRuntimeOverrides = null;
        }
      }
    } catch (error) {
      logger === null || logger === void 0 ? void 0 : logger.error(`failed to get unisphereRuntimeOverrides from window, ignore window dev overrides`, {
        error
      });
      windowRuntimeOverrides = null;
    }
  }
  if (allowExternalOverrides) {
    try {
      const queryParamsAsString = getQueryParam('unisphereRuntimeOverrides');
      if (queryParamsAsString) {
        logger === null || logger === void 0 ? void 0 : logger.log(`using dev overrides from query params`);
        queryParamsRuntimeOverrides = JSON.parse(window.atob(queryParamsAsString.replace(/%3[dD]/g, '=')));
        if (!isRuntimeOverrides(queryParamsRuntimeOverrides, logger)) {
          logger === null || logger === void 0 ? void 0 : logger.warn(`invalid dev overrides provided in query params, ignore query params dev overrides`, {
            data: {
              result: queryParamsRuntimeOverrides
            }
          });
          queryParamsRuntimeOverrides = null;
        }
      }
    } catch (error) {
      logger === null || logger === void 0 ? void 0 : logger.error(`failed to get unisphereRuntimeOverrides from query params, ignore query params dev overrides`, {
        error
      });
      queryParamsRuntimeOverrides = null;
    }
  }
  cachedRuntimeOverrides$1 = {
    allowQueryParamsOverrides: allowExternalOverrides,
    allowStorageOverrides: !!(allowStorageOverridesRule === null || allowStorageOverridesRule === void 0 ? void 0 : allowStorageOverridesRule.storageType),
    allowWindowOverrides: allowExternalOverrides,
    queryParamsRuntimeOverrides: queryParamsRuntimeOverrides || null,
    storageRuntimeOverrides: storageRuntimeOverrides || null,
    windowRuntimeOverrides: windowRuntimeOverrides || null
  };
  return cachedRuntimeOverrides$1;
};

let cachedRuntimeOverrides = null;
const getCurrentEnvManifestOverride = ({
  logger,
  currentEnvManifest
}) => {
  if (cachedRuntimeOverrides) {
    return cachedRuntimeOverrides;
  }
  const {
    queryParamsRuntimeOverrides,
    storageRuntimeOverrides,
    windowRuntimeOverrides,
    allowQueryParamsOverrides: queryParamsEnabled,
    allowStorageOverrides: storageEnabled,
    allowWindowOverrides: windowEnabled
  } = getAllEnvManifestOverrides(currentEnvManifest, logger);
  cachedRuntimeOverrides = (queryParamsEnabled ? queryParamsRuntimeOverrides : null) || (storageEnabled ? storageRuntimeOverrides : null) || (windowEnabled ? windowRuntimeOverrides : null);
  return cachedRuntimeOverrides;
};

const unisphereEnv$1 = getUnisphereEnv();
const isValidVersion = token => {
  // more strict
  // const semverRegex =
  //   /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
  const semverRegex = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-[0-9A-Za-z-]+(?:\.[0-9]+)*)?$/;
  return semverRegex.test(token);
};
const isValidUrl = url => {
  try {
    new URL(url);
    return true;
  } catch (_a) {
    return false;
  }
};
const maybeGetURLOfRuntimeFromOverrides = ({
  customRuntimeTokenFromOverrides,
  resolvedBaseEnv,
  widgetShortName,
  runtimeName,
  logger,
  widgetName,
  currentEnvManifest
}) => {
  if (customRuntimeTokenFromOverrides && isValidVersion(customRuntimeTokenFromOverrides)) {
    let result = createUrlWihtoutDomainCheck({
      token: customRuntimeTokenFromOverrides,
      baseEnvName: resolvedBaseEnv,
      widgetShortName,
      runtimeName,
      forceSecure: true
    });
    logger === null || logger === void 0 ? void 0 : logger.log(`custom token is valid version, using dev overrides for widget ${widgetName} and runtime ${runtimeName}, doesn't require origin check`, {
      overrides: {
        widgetName,
        runtimeName
      },
      data: {
        args: {
          result,
          customTokenFromDevOverrides: customRuntimeTokenFromOverrides
        }
      }
    });
    return result;
  } else if (customRuntimeTokenFromOverrides && (isLocalPort(customRuntimeTokenFromOverrides) || isValidUrl(customRuntimeTokenFromOverrides))) {
    let result = createUrlWihtoutDomainCheck({
      token: customRuntimeTokenFromOverrides,
      baseEnvName: resolvedBaseEnv,
      widgetShortName,
      runtimeName
    });
    const hasPassedOriginCheck = checkOrigin({
      url: result,
      currentEnvManifest,
      logger
    });
    if (hasPassedOriginCheck) {
      logger === null || logger === void 0 ? void 0 : logger.log(`custom token is valid url, using dev overrides for widget ${widgetName} and runtime ${runtimeName}.`, {
        overrides: {
          widgetName,
          runtimeName
        },
        data: {
          args: {
            hasPassedOriginCheck,
            customTokenFromDevOverrides: customRuntimeTokenFromOverrides
          }
        }
      });
      return result;
    } else {
      logger === null || logger === void 0 ? void 0 : logger.warn(`custom token is valid url, but origin check failed, ignore dev overrides for widget ${widgetName} and runtime ${runtimeName}.`, {
        overrides: {
          widgetName,
          runtimeName
        },
        data: {
          args: {
            hasPassedOriginCheck,
            customTokenFromDevOverrides: customRuntimeTokenFromOverrides
          }
        }
      });
    }
  } else if (customRuntimeTokenFromOverrides) {
    logger === null || logger === void 0 ? void 0 : logger.warn(`custom token is not valid version or url, ignoring dev overrides for widget ${widgetName} and runtime ${runtimeName}`, {
      overrides: {
        widgetName,
        runtimeName
      },
      data: {
        args: {
          customTokenFromDevOverrides: customRuntimeTokenFromOverrides
        }
      }
    });
  }
};
const isLocalPort = token => {
  return /^\d{4}$/.test(token);
};
const canUseRequestedEnv = ({
  resolvedBaseEnv,
  currentEnvManifest,
  logger,
  widgetName,
  runtimeName
}) => {
  if (resolvedBaseEnv !== currentEnvManifest.env.toLowerCase()) {
    const allowCustomBaseEnvironment = currentEnvManifest.rules.reduce((acc, rule) => {
      if (rule.type === 'allow-base-environment') {
        acc.push(rule.baseEnvName.toLowerCase());
      }
      return acc;
    }, []);
    if (!allowCustomBaseEnvironment.includes(resolvedBaseEnv)) {
      logger === null || logger === void 0 ? void 0 : logger.warn(`custom base environment ${resolvedBaseEnv} is not allowed for widget ${widgetName} and runtime ${runtimeName}`, {
        data: {
          args: {
            baseEnv: resolvedBaseEnv,
            widgetName,
            runtimeName
          }
        },
        overrides: {
          widgetName,
          runtimeName
        }
      });
      return false;
    }
  }
  return true;
};
const extractPortFromUrl = url => {
  try {
    if (url.includes('localhost:')) {
      const urlObj = new URL(url);
      return urlObj.port;
    }
    return url;
  } catch (error) {
    return url;
  }
};
const getEnvironmentVersionFromRule = ({
  widgetName,
  runtimeName,
  applicationName,
  applicationVersion,
  currentEnvManifest,
  logger
}) => {
  const rule = currentEnvManifest.rules.find(rule => rule.type === 'customized-version' && rule.widgetName === widgetName && rule.applicationName === applicationName && rule.runtimeName === runtimeName && rule.applicationVersion === applicationVersion);
  if (rule) {
    logger === null || logger === void 0 ? void 0 : logger.warn(`override environment version from rule for widget ${widgetName}, runtime ${runtimeName}, application ${applicationName}, rule version ${rule.version}`, {
      overrides: {
        widgetName,
        runtimeName
      }
    });
    return rule.version;
  }
  return null;
};
const checkOrigin = ({
  url,
  currentEnvManifest,
  logger
}) => {
  const isSecure = window.location.protocol === 'https:';
  const envBaseUrl = `http${isSecure ? 's' : ''}://unisphere.${currentEnvManifest.env}.ovp.kaltura.com/v1/`;
  const isInEnvironmentArtifacts = url.startsWith(envBaseUrl);
  const isInAllowedDomains = currentEnvManifest.domains.some(domain => url.startsWith(domain));
  logger === null || logger === void 0 ? void 0 : logger.debug(`checking origin rules for url '${url}'`, {
    data: {
      args: {
        url,
        isInEnvironmentArtifacts,
        isInAllowedDomains
      }
    }
  });
  return isInEnvironmentArtifacts || isInAllowedDomains;
};
const supportedWidgetNamespaces = ['unisphere.widget', 'kaltura.widget', 'unisphere.runtime'];
const isWidgetNameValid = (widgetName, runtimeName, logger) => {
  if (widgetName.split('.').length !== 3 || !supportedWidgetNamespaces.some(namespace => widgetName.startsWith(namespace))) {
    logger === null || logger === void 0 ? void 0 : logger.warn(`widget namespace is not supported for widget ${widgetName} and runtime ${runtimeName}`, {
      data: {
        args: {
          widgetName
        }
      },
      overrides: {
        widgetName,
        runtimeName
      }
    });
    return false;
  }
  return true;
};
const getRuntimeUrl = _a => __awaiter(void 0, [_a], void 0, function* ({
  widgetName,
  runtimeName,
  currentEnvManifest,
  logger,
  specificVersion,
  applicationName,
  applicationVersion,
  disableOverrides,
  suspendMissingWarning
}) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
  const runtimeOverrides = disableOverrides ? null : getCurrentEnvManifestOverride({
    logger,
    currentEnvManifest
  });
  if (!isWidgetNameValid(widgetName, runtimeName, logger)) {
    return '';
  }
  const widgetShortName = widgetName === null || widgetName === void 0 ? void 0 : widgetName.split('.')[2];
  const customWidgetRuntimeFromOverrides = (_c = (_b = runtimeOverrides === null || runtimeOverrides === void 0 ? void 0 : runtimeOverrides.runtimes) === null || _b === void 0 ? void 0 : _b[widgetName]) === null || _c === void 0 ? void 0 : _c[runtimeName];
  let resolvedBaseEnv = ((_d = customWidgetRuntimeFromOverrides === null || customWidgetRuntimeFromOverrides === void 0 ? void 0 : customWidgetRuntimeFromOverrides.baseEnvName) === null || _d === void 0 ? void 0 : _d.toLowerCase()) || ((_e = runtimeOverrides === null || runtimeOverrides === void 0 ? void 0 : runtimeOverrides.baseEnvName) === null || _e === void 0 ? void 0 : _e.toLowerCase()) || null;
  if (!resolvedBaseEnv || !canUseRequestedEnv({
    resolvedBaseEnv,
    currentEnvManifest,
    logger,
    widgetName,
    runtimeName
  })) {
    resolvedBaseEnv = currentEnvManifest.env.toLowerCase();
  }
  let resolvedSpecificVersion = null;
  if (specificVersion) {
    const allowSpecificVersion = (_h = (_g = (_f = currentEnvManifest === null || currentEnvManifest === void 0 ? void 0 : currentEnvManifest.versions.widgets) === null || _f === void 0 ? void 0 : _f[widgetName]) === null || _g === void 0 ? void 0 : _g.runtimes) === null || _h === void 0 ? void 0 : _h[runtimeName].allowSpecificVersion;
    if (allowSpecificVersion) {
      resolvedSpecificVersion = specificVersion;
    } else {
      logger === null || logger === void 0 ? void 0 : logger.warn(`specific version ${specificVersion} requested but, specific version is not allowed for widget ${widgetName} and runtime ${runtimeName}. returning with empty url`, {
        data: {
          args: {
            widgetName,
            runtimeName
          }
        },
        overrides: {
          widgetName,
          runtimeName
        }
      });
      return '';
    }
  }
  let customRuntimeTokenFromOverrides = customWidgetRuntimeFromOverrides === null || customWidgetRuntimeFromOverrides === void 0 ? void 0 : customWidgetRuntimeFromOverrides.token;
  const runtimeUrlFromOverrides = maybeGetURLOfRuntimeFromOverrides({
    customRuntimeTokenFromOverrides,
    resolvedBaseEnv,
    widgetShortName,
    runtimeName,
    logger,
    widgetName,
    currentEnvManifest
  });
  if (runtimeUrlFromOverrides) {
    logger === null || logger === void 0 ? void 0 : logger.debug(`resolved runtime version '${runtimeUrlFromOverrides}', based on custom runtime override`, {
      overrides: {
        widgetName,
        runtimeName
      }
    });
    return runtimeUrlFromOverrides;
  }
  const runtimeJsonFromCustomEnv = (resolvedBaseEnv === null || resolvedBaseEnv === void 0 ? void 0 : resolvedBaseEnv.toLowerCase()) !== ((_j = currentEnvManifest === null || currentEnvManifest === void 0 ? void 0 : currentEnvManifest.env) === null || _j === void 0 ? void 0 : _j.toLowerCase()) ? (_p = (_o = (_m = (_l = (_k = yield fetchEnvManifest({
    envName: resolvedBaseEnv,
    logger
  })) === null || _k === void 0 ? void 0 : _k.versions.widgets) === null || _l === void 0 ? void 0 : _l[widgetName]) === null || _m === void 0 ? void 0 : _m.runtimes) === null || _o === void 0 ? void 0 : _o[runtimeName]) === null || _p === void 0 ? void 0 : _p.version : null;
  const runtimeJsonFromCurrentEnv = (_t = (_s = (_r = (_q = currentEnvManifest === null || currentEnvManifest === void 0 ? void 0 : currentEnvManifest.versions.widgets) === null || _q === void 0 ? void 0 : _q[widgetName]) === null || _r === void 0 ? void 0 : _r.runtimes) === null || _s === void 0 ? void 0 : _s[runtimeName]) === null || _t === void 0 ? void 0 : _t.version;
  const runtimeJsonFromEnvRule = applicationName && applicationVersion ? getEnvironmentVersionFromRule({
    widgetName,
    runtimeName,
    applicationName,
    applicationVersion,
    currentEnvManifest,
    logger
  }) : null;
  const prioritizationOrder = ['specific', 'env manifest rule', 'custom env manifest', 'current env manifest'];
  let resolvedRuntimeVersion;
  if (resolvedSpecificVersion) {
    resolvedRuntimeVersion = resolvedSpecificVersion;
    prioritizationOrder[0] = 'specific (*)';
  } else if (runtimeJsonFromEnvRule) {
    resolvedRuntimeVersion = runtimeJsonFromEnvRule;
    prioritizationOrder[1] = 'env manifest rule (*)';
  } else if (runtimeJsonFromCustomEnv) {
    resolvedRuntimeVersion = runtimeJsonFromCustomEnv;
    prioritizationOrder[2] = 'custom env manifest (*)';
  } else if (runtimeJsonFromCurrentEnv) {
    resolvedRuntimeVersion = runtimeJsonFromCurrentEnv;
    prioritizationOrder[3] = 'current env manifest (*)';
  }
  logger === null || logger === void 0 ? void 0 : logger.debug(`resolved runtime version '${resolvedRuntimeVersion}', based on prioritization: ${prioritizationOrder.join(' > ')}`, {
    overrides: {
      widgetName,
      runtimeName
    },
    data: {
      runtimeJsonFromCurrentEnv,
      runtimeJsonFromResolvedEnv: runtimeJsonFromCustomEnv,
      specificVersion,
      runtimeJsonFromEnvRule,
      resolvedBaseEnv,
      resolvedSpecificVersion
    }
  });
  if (resolvedRuntimeVersion && isValidVersion(resolvedRuntimeVersion)) {
    let result = createUrlWihtoutDomainCheck({
      token: resolvedRuntimeVersion,
      baseEnvName: resolvedBaseEnv,
      widgetShortName,
      runtimeName,
      forceSecure: true
    });
    logger === null || logger === void 0 ? void 0 : logger.log(`get runtime url for widget '${widgetName}' and runtime '${runtimeName}' from environment runtime version`, {
      overrides: {
        widgetName,
        runtimeName
      },
      data: {
        args: {
          result,
          environmentRuntimeVersion: runtimeJsonFromCurrentEnv,
          widgetShortName,
          runtimeName
        }
      }
    });
    return result;
  }
  if (suspendMissingWarning) {
    return '';
  }
  logger === null || logger === void 0 ? void 0 : logger.warn(`environment runtime version not found for widget '${widgetName}' and runtime '${runtimeName}'`, {
    data: {
      args: {}
    },
    overrides: {
      widgetName,
      runtimeName
    }
  });
  return '';
});
const createUrlWihtoutDomainCheck = ({
  token,
  baseEnvName,
  widgetShortName,
  runtimeName,
  forceSecure
}) => {
  const isSecure = forceSecure || window.location.protocol === 'https:';
  const fileName = `index${unisphereEnv$1.environment === 'dev' ? '.dev' : ''}.esm.js`;
  if (isValidVersion(token)) {
    if (widgetShortName === 'core' && runtimeName === 'workspace') {
      return `http${isSecure ? 's' : ''}://unisphere.${baseEnvName}.ovp.kaltura.com/v1/static/workspace/v${token}/runtime/${fileName}`;
    } else if (widgetShortName === 'core' && runtimeName === 'loader') {
      return `http${isSecure ? 's' : ''}://unisphere.${baseEnvName}.ovp.kaltura.com/v1/static/loader/v${token}/runtime/${fileName}`;
    }
    return `http${isSecure ? 's' : ''}://unisphere.${baseEnvName}.ovp.kaltura.com/v1/static/modules/${widgetShortName}/v${token}/runtime/${runtimeName}/${fileName}`;
  } else if (/^\d{4}$/.test(token)) {
    return `http${isSecure ? 's' : ''}://localhost:${token}/index.dev.esm.js`;
  }
  return token || '';
};

function waitForUnisphere() {
  const windowAsAny = window;
  return new Promise(resolve => {
    var _a, _b;
    if ((_b = (_a = windowAsAny.unisphere) === null || _a === void 0 ? void 0 : _a.instancesManager) === null || _b === void 0 ? void 0 : _b.get) {
      resolve({
        getByWorkspaceName: windowAsAny.unisphere.instancesManager.get,
        getByPresetName: windowAsAny.unisphere.instancesManager.getByPresetName || (() => {
          console.warn('getByPresetName not implemented');
          return Promise.reject(new Error());
        })
      });
    } else {
      const onReady = () => {
        document.removeEventListener('unisphere-ready', onReady);
        resolve({
          getByWorkspaceName: windowAsAny.unisphere.instancesManager.get,
          getByPresetName: windowAsAny.unisphere.instancesManager.getByPresetName
        });
      };
      document.addEventListener('unisphere-ready', onReady);
    }
  });
}
function getUnisphereInstance(workspaceId) {
  return __awaiter(this, void 0, void 0, function* () {
    const {
      getByWorkspaceName
    } = yield waitForUnisphere();
    return getByWorkspaceName(workspaceId);
  });
}
function getUnisphereInstanceByPresetName(presetName) {
  return __awaiter(this, void 0, void 0, function* () {
    const {
      getByPresetName
    } = yield waitForUnisphere();
    return getByPresetName(presetName);
  });
}

const extractRuntimesFromJson = (runtimeJson, appName, appVersion, logger) => __awaiter(void 0, void 0, void 0, function* () {
  logger.debug(`extracting workspace runtimes from runtime json`, {
    data: {
      runtimeJson
    }
  });
  // Create an empty result structure
  const runtimes = {
    widgets: {}
  };
  // Process each widget entry
  for (const [widgetName, {
    runtimes: widgetRuntimes
  }] of Object.entries(runtimeJson.versions.widgets)) {
    runtimes.widgets[widgetName] = {
      runtimes: {}
    };
    // Process each runtime for the current widget
    for (const runtimeName of Object.keys(widgetRuntimes)) {
      try {
        const url = yield getRuntimeUrl({
          widgetName,
          runtimeName,
          applicationName: appName,
          applicationVersion: appVersion,
          currentEnvManifest: runtimeJson,
          logger
        });
        if (url) {
          runtimes.widgets[widgetName].runtimes[runtimeName] = {
            url
          };
        } else {
          logger.warn(`failed to figure out runtime url for widget '${widgetName}' runtime '${runtimeName}', got empty url, ignore runtime`);
        }
      } catch (error) {
        logger.warn(`failed to figure out runtime url for widget '${widgetName}' runtime '${runtimeName}', ignore runtime`, {
          data: {
            error
          }
        });
      }
    }
  }
  const envManifestOverrides = getCurrentEnvManifestOverride({
    logger,
    currentEnvManifest: runtimeJson
  });
  if (envManifestOverrides) {
    for (const [widgetName, widgetRuntimes] of Object.entries(envManifestOverrides.runtimes)) {
      if (!runtimes.widgets[widgetName]) {
        runtimes.widgets[widgetName] = {
          runtimes: {}
        };
      }
      // Process each runtime for the current widget
      for (const runtimeName of Object.keys(widgetRuntimes)) {
        try {
          if (!runtimes.widgets[widgetName].runtimes[runtimeName]) {
            if (widgetName === 'unisphere.widget.core' && runtimeName === 'loader') {
              continue;
            }
            const url = yield getRuntimeUrl({
              widgetName,
              runtimeName,
              applicationName: appName,
              applicationVersion: appVersion,
              currentEnvManifest: runtimeJson,
              logger
            });
            if (url) {
              runtimes.widgets[widgetName].runtimes[runtimeName] = {
                url
              };
            } else {
              logger.warn(`failed to figure out runtime url for widget '${widgetName}' runtime '${runtimeName}', got empty url, ignore runtime override`);
            }
          }
        } catch (error) {
          logger.warn(`failed to figure out runtime url for widget '${widgetName}' runtime '${runtimeName}', ignore runtime override`, {
            data: {
              error
            }
          });
        }
      }
    }
  }
  return runtimes;
});

const unisphereEnv = getUnisphereEnv();
const envManifestsByEnvCache = new Map();
const fetchEnvManifest = _a => __awaiter(void 0, [_a], void 0, function* ({
  envName,
  logger
}) {
  const cachedManifest = envManifestsByEnvCache.get(envName);
  if (cachedManifest) {
    return cachedManifest;
  }
  let envManifestUrl = `https://unisphere.${envName}.ovp.kaltura.com/v1/runtime.json`;
  let envManifestJson;
  try {
    logger.log(`loading environment manifest for env '${envName}' from '${envManifestUrl}'`);
    envManifestJson = yield fetch(envManifestUrl).then(res => res.json());
  } catch (error) {
    logger.error(`error loading environment manifest for env from '${envManifestUrl}'`, {
      error
    });
    throw new Error(`failed to load environment manifest for env from '${envManifestUrl}'`);
  }
  if (!isUnisphereEnvManifestJsonV2(envManifestJson, logger)) {
    throw new Error(`invalid environment manifest`);
  }
  if (unisphereEnv.presets) {
    unisphereEnv.presets.activate.forEach(presetName => {
      var _a;
      logger.debug(`activating preset '${presetName}' from env presets`);
      const preset = (_a = envManifestJson.presets) === null || _a === void 0 ? void 0 : _a[presetName];
      if (!preset) {
        logger.warn(`preset '${presetName}' not found in environment manifest, cannot activate`);
      } else {
        preset.active = true;
      }
    });
    unisphereEnv.presets.deactivate.forEach(presetName => {
      var _a;
      logger.debug(`dectivating preset '${presetName}' from env presets`);
      const preset = (_a = envManifestJson.presets) === null || _a === void 0 ? void 0 : _a[presetName];
      if (!preset) {
        logger.warn(`preset '${presetName}' not found in environment manifest, cannot deactivate`);
      } else {
        preset.active = false;
      }
    });
  }
  logger.debug(`cached environment manifest for env '${envName}'`);
  envManifestsByEnvCache.set(envName, envManifestJson);
  return envManifestJson;
});

const DEFAULT_LANGUAGE = 'en-US';
const DEFAULT_LANGUAGE_WITHOUT_REGION = 'en';
// Helper function to normalize language codes
const normalizeLanguageCode = langCode => {
  const normalizedLanguage = langCode.trim();
  const parts = normalizedLanguage.split('-');
  if (parts.length === 1) {
    // Only language code provided (e.g., "en")
    const _langCode = parts[0].toLowerCase();
    if (/^[a-z]{2}$/.test(_langCode)) {
      return _langCode;
    }
    // Invalid format, fallback to default
    console.warn(`Invalid language code format: ${_langCode}, falling back to ${DEFAULT_LANGUAGE}`);
    return DEFAULT_LANGUAGE;
  }
  if (parts.length === 2) {
    // Language and region code provided (e.g., "en-US")
    const _langCode2 = parts[0].toLowerCase();
    const regionCode = parts[1].toUpperCase();
    if (/^[a-z]{2}$/.test(_langCode2) && /^[A-Z]{2}$/.test(regionCode)) {
      return `${_langCode2}-${regionCode}`;
    }
    // Invalid format, fallback to default
    console.warn(`Invalid language-region code format: ${_langCode2}-${regionCode}, falling back to ${DEFAULT_LANGUAGE}`);
    return DEFAULT_LANGUAGE;
  }
  // Too many parts, fallback to default
  console.warn(`Invalid language code format: ${langCode}, falling back to ${DEFAULT_LANGUAGE}`);
  return DEFAULT_LANGUAGE;
};

const deepMerge = (target, source) => {
  const result = Object.assign({}, target);
  Object.keys(source).forEach(key => {
    // Check if both source and target values are objects and not null or arrays
    if (source[key] !== null && typeof source[key] === 'object' && !Array.isArray(source[key]) && target[key] !== null && typeof target[key] === 'object' && !Array.isArray(target[key])) {
      // Recursively merge nested objects
      result[key] = deepMerge(target[key], source[key]);
    } else {
      // For non-objects, arrays, or when target doesn't have the key, use source value directly
      result[key] = source[key];
    }
  });
  return result;
};

class UnisphereRuntimeBase extends UnisphereElementBase {}

export { DEFAULT_LANGUAGE, DEFAULT_LANGUAGE_WITHOUT_REGION, UnisphereElementBase, UnisphereElementFactory, UnisphereLoadError, UnisphereRuntimeBase, deepMerge, extractPortFromUrl, extractRuntimesFromJson, fetchAndLoadUnisphereWorkspace, fetchArtifact, fetchEnvManifest, getAllEnvManifestOverrides, getCurrentEnvManifestOverride, getQueryParam, getRuntimeUrl, getUnisphereEnv, getUnisphereInstance, getUnisphereInstanceByPresetName, isLocalPort, isValidUrl, isValidVersion, normalizeLanguageCode, reserveWorkspaceByApplication, workspaceVersion };
